import React, { useState, useEffect } from "react";
import "./banner.scss";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../header/Navbar";
import Modal from "react-bootstrap/Modal";
import EthPrice from "../../../hooks/chinaFunction/ethPrice";
import UniPrice from "../../../hooks/chinaFunction/uniPrice";
import LinkPrice from "../../../hooks/chinaFunction/linkPrice";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../../../hooks/useWeb3";
import moment from "moment";
import AllowanceTpl from "../../../hooks/dataFetchers/AllowanceTpl";
import AllowanceTpl1 from "../../../hooks/dataFetchers/AllowanceTpl1";
import ApproveTpl from "../../../hooks/dataFetchers/ApproveTpl";
import ApproveTplUsdc from "../../../hooks/dataFetchers/ApproveTplUsdc";
import ApproveTplUsdc1 from "../../../hooks/dataFetchers/approveTplUsdc1";
import ApproveTplWbtc from "../../../hooks/dataFetchers/ApproveTplWbtc";
import ApproveTplWbtc1 from "../../../hooks/dataFetchers/approveTplWbtc1";
import ApproveTomi from "../../../hooks/dataFetchers/ApproveTomi";
import ApproveGems from "../../../hooks/dataFetchers/ApproveGems";
import ApproveLink from "../../../hooks/dataFetchers/ApproveLink";
import ApprovePepe from "../../../hooks/dataFetchers/ApprovePepe";
import ApproveUnisawape from "../../../hooks/dataFetchers/ApproveUniswape";
import ApproveTomi1 from "../../../hooks/dataFetchers/ApproveTomi1";
import ApproveTpl1 from "../../../hooks/dataFetchers/ApproveTpl1";
import BalacefAccount from "../../../hooks/dataFetchers/BalaceOfAccount";
import PurchaseEth from "../../../hooks/chinaFunction/purchaseEth";
import PurchaseEth1 from "../../../hooks/chinaFunction/purchaseEth1";
import PurchaseUsdt from "../../../hooks/chinaFunction/purchaseUsdt";
import PurchaseUsdc from "../../../hooks/chinaFunction/purchaseUsdc";
import PurchaseUsdc1 from "../../../hooks/chinaFunction/purchaseUsdc1";
import PurchaseWbtc from "../../../hooks/chinaFunction/purchaseWbtc";
import PurchaseWbtc1 from "../../../hooks/chinaFunction/purchaseWbtc1";
import PurchaseUsdt1 from "../../../hooks/chinaFunction/purchaseUsdt1";
import PurchasePepe from "../../../hooks/chinaFunction/purchasePepe";
import PurchaseLink from "../../../hooks/chinaFunction/purchaseLink";
import PurchaseUniswape from "../../../hooks/chinaFunction/purchaseUniswape";
import Loader from "../../../hooks/loader";
import axios from "axios";
import { API_URL } from "../../../utils/ApiUrl";
import { toast } from "react-toastify";
import CuurentRound from "../../../hooks/chinaFunction/round";
import SaleStatus from "../../../hooks/chinaFunction/saleStatus";
import Timer from "../../../hooks/chinaFunction/timer";
import TimerNft from "../../../hooks/chinaFunction/timeNft";
import { useHistory } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DopNft from "../../DopNft/DopNft";
import BalacefAccountTomi from "../../../hooks/dataFetchers/BlanaceOfAccountTom";
import BalacefAccountGems from "../../../hooks/dataFetchers/BlanaceOfAccountGems";
import BalacefAccountLink from "../../../hooks/dataFetchers/BalacefAccountLink";
import BalacefAccountPepe from "../../../hooks/dataFetchers/BalacefAccountPepe";
import BalacefAccountUni from "../../../hooks/dataFetchers/BalacefAccountUni";
import BalacefAccountUsdc from "../../../hooks/dataFetchers/BalanceOfAccountUsdc";
import BalacefAccountWbtc from "../../../hooks/dataFetchers/BalanceOfAccountWbtc";
import AllowanceTomi from "../../../hooks/dataFetchers/AllowanceTomi";
import AllowanceGems from "../../../hooks/dataFetchers/AllowanceGems";
import AllowanceLink from "../../../hooks/dataFetchers/AllowanceLink";
import AllowancePepe from "../../../hooks/dataFetchers/AllowancePepe";
import AllowanceUniswape from "../../../hooks/dataFetchers/AllowanceUniswape";
import AllowanceUsdc from "../../../hooks/dataFetchers/AllowanceUsdc";
import AllowanceUsdc1 from "../../../hooks/dataFetchers/AllowanceUsdc1";
import AllowanceWbtc from "../../../hooks/dataFetchers/AllowanceWbtc";
import AllowanceWbtc1 from "../../../hooks/dataFetchers/AllowanceWbtc1";
import AllowanceTomi1 from "../../../hooks/dataFetchers/AllowanceTomi1";
import PurchaseTomi from "../../../hooks/chinaFunction/purchaseTomi";
import PurchaseTomi1 from "../../../hooks/chinaFunction/puchaseTomi1";
import DiscountedPrice from "../../../hooks/chinaFunction/discountedPrice";
import Environment from "../../../utils/Environment";
import WbtcPrice from "../../../hooks/chinaFunction/wbtcPrice";
import AllowanceDop from "../../../hooks/dataFetchers/AllowanceDop";
import ApproveDop from "../../../hooks/dataFetchers/ApproveDop";
import PurchaseDop from "../../../hooks/chinaFunction/purchaseDop";
import AllowanceDop1 from "../../../hooks/dataFetchers/AllowanceDop1";
import ApproveDop1 from "../../../hooks/dataFetchers/ApproveDop1";
import PurchaseDop1 from "../../../hooks/chinaFunction/purchaseDop1";
import BalacefAccountDop from "../../../hooks/dataFetchers/balanceOfAccountDop";
import { setupNetwork } from "../../../utils/wallet";
import GetGemsStakedIndex from "../../../hooks/chinaFunction/getGemsStakedIndex";
import GetGemsStaked from "../../../hooks/chinaFunction/getGemsStakeAmount";
import { storeReferrer } from "@sharemint/sdk";
import PurchaseGems from "../../../hooks/chinaFunction/purchaseGems";
import PurchaseGems1 from "../../../hooks/chinaFunction/purchaseGems1";
import AllowanceGems1 from "../../../hooks/dataFetchers/AllowanceGems1";
import ApproveGems1 from "../../../hooks/dataFetchers/ApproveGems1";
import InsurancePercentage from "../../../hooks/dataFetchers/insurancePercentage";
import useRecordEvent from "../../../hooks/useRecordEvent";
import Footer from "../Footer/Footer";
import RoundTimer from "./RoundTimer";

const CHAIN = process.env.REACT_APP_CHAIN_ID;

const Banner = ({ setShow }) => {
  // let sharemintValue = localStorage.getItem("sharemint");
  let ipBuyer = localStorage.getItem("ip");
  let countryBuyer = localStorage.getItem("country");
  const Presale = Environment?.presale;
  // const { recordEvent } = useRecordEvent();
  const [checkBoxx, setCheckBoxx] = useState(false);
  const [insurancePer, setInsurancePer] = useState(0);
  // const { allowanceDop } = AllowanceDop();
  // const { allowanceDop1 } = AllowanceDop1();
  const { approveDop } = ApproveDop();
  const { approveDop1 } = ApproveDop1();
  const { purchaseDop } = PurchaseDop();
  const { purchaseDop1 } = PurchaseDop1();
  // const { balacefAccountDop } = BalacefAccountDop();
  const history = useHistory();
  const { getGemsStaked } = GetGemsStaked();
  // const { getGemsStakedIndex } = GetGemsStakedIndex();
  // const { allowanceLink } = AllowanceLink();
  // const { allowanceTomi } = AllowanceTomi();
  const { allowanceGems } = AllowanceGems();
  // const { allowancePepe } = AllowancePepe();
  // const { allowanceUniswape } = AllowanceUniswape();
  const { allowanceUsdc } = AllowanceUsdc();
  // const { allowanceWbtc } = AllowanceWbtc();
  // const { allowanceUsdc1 } = AllowanceUsdc1();
  // const { allowanceWbtc1 } = AllowanceWbtc1();
  // const { allowanceTomi1 } = AllowanceTomi1();
  const { cuurentRound } = CuurentRound();
  // const { cuurentRoundNft } = CuurentRoundNft();
  const { saleStatus } = SaleStatus();
  // const { saleStatusNft } = SaleStatusNft();
  // const { insurancePercentage } = InsurancePercentage();
  // const { psMarketCap } = PsMarketCap();
  // const { inMarketCap } = InMarketCap();
  // const { psTotalPurchase } = PsTotalPurchase();
  // const { inTotalPurchase } = InTotalPurchase();
  // const { saleStatus1 } = SaleStatus1();
  const { timer } = Timer();
  const { timerNft } = TimerNft();
  const { purchaseTomi } = PurchaseTomi();
  const { purchaseGems } = PurchaseGems();
  const { approveGems1 } = ApproveGems1();
  const { purchaseGems1 } = PurchaseGems1();
  // const { allowanceGems1 } = AllowanceGems1();
  const [gemsAllowance1, setGemsAllwance1] = useState(null);
  const { purchaseTomi1 } = PurchaseTomi1();
  const { discountedPrice } = DiscountedPrice();
  const [psTotlaPurchasess, setPsTotlaPurchasess] = useState(null);
  const [inTotlaPurchasess, setInTotlaPurchasess] = useState(null);
  const [psmyTotlaPurchasess, setMyPsTotlaPurchasess] = useState(null);
  const [inMyTotlaPurchasess, setMyInTotlaPurchasess] = useState(null);
  const [psMaxxCap, setPsMaxxCap] = useState(null);
  // const [inMaxxCap, setInMaxxCap] = useState(null);
  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakingData, setStakingData] = useState([]);
  var now11 = new Date();
  let createdDate = now11?.getTime();

  useEffect(() => {
    storeReferrer();
    return () => {};
  }, []);
  // console.log(createdDate,'createdDate');
  // const capHandler = async () => {
  //   try {

  //     // const { psMarketCap } = PsMarketCap()
  //     // const { inMarketCap } = InMarketCap()
  //     // const { psTotalPurchase } = PsTotalPurchase()
  //     // const { inTotalPurchase } = InTotalPurchase()
  //     let a = await psMarketCap()
  //     setPsMaxxCap(a)
  //     let b = await inMarketCap()
  //     setInMaxxCap(b)
  //     let c = await psTotalPurchase()
  //     setPsTotlaPurchasess(c)
  //     let v = await inTotalPurchase()
  //     setInTotlaPurchasess(v)
  //     // console.log(a,b,v,c,'total cap');
  //   } catch (err) {
  //     console.log(err, 'err from cap');

  //   }
  // }
  // // console.log(psMaxxCap,psmyTotlaPurchasess,'nooooooooor',psTotlaPurchasess);
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  const objjjj = localStorage?.getItem("oobjj");
  const code = localStorage?.getItem("accessCode");
  const instiPrice = localStorage?.getItem("price_ins");
  const role = localStorage?.getItem("role_ins");
  const email = localStorage?.getItem("email");
  const modalTwitter = localStorage?.getItem("twittter");
  const startTime11 = localStorage?.getItem("timeeee");
  const [id, setId] = useState(null);
  const [price, setPrice] = useState(null);
  const [round, setRound] = useState(null);
  const [loaderr, setLoarder] = useState(false);
  const [loaderr1, setLoarder1] = useState(false);
  const { purchaseUsdt } = PurchaseUsdt();
  const { purchaseUsdc } = PurchaseUsdc();
  const { purchaseUsdc1 } = PurchaseUsdc1();
  const { purchaseWbtc } = PurchaseWbtc();
  const { purchaseWbtc1 } = PurchaseWbtc1();
  const { purchasePepe } = PurchasePepe();
  const { purchaseLink } = PurchaseLink();
  const { purchaseUniswape } = PurchaseUniswape();
  const { purchaseEth } = PurchaseEth();
  const { purchaseUsdt1 } = PurchaseUsdt1();
  const { purchaseEth1 } = PurchaseEth1();
  const { approveTpl } = ApproveTpl();
  const { approveTplUsdc } = ApproveTplUsdc();
  const { approveTplwbtc } = ApproveTplWbtc();
  const { approveTplUsdc1 } = ApproveTplUsdc1();
  const { approveTplwbtc1 } = ApproveTplWbtc1();
  const { approveTomi } = ApproveTomi();
  const { approveGems } = ApproveGems();
  const { approveLink } = ApproveLink();
  const { approvePepe } = ApprovePepe();
  const { approveUnisawape } = ApproveUnisawape();
  const { approveTomi1 } = ApproveTomi1();
  const { approveTpl1 } = ApproveTpl1();
  const { allowanceTpl } = AllowanceTpl();
  // const { allowanceTpl1 } = AllowanceTpl1();
  const { balacefAccount } = BalacefAccount();
  // const { balacefAccountTomi } = BalacefAccountTomi();
  const { balacefAccountGems } = BalacefAccountGems();
  // const { balacefAccountLink } = BalacefAccountLink();
  // const { balacefAccountUni } = BalacefAccountUni();
  // const { balacefAccountPepe } = BalacefAccountPepe();
  const { balacefAccountUsdc } = BalacefAccountUsdc();
  // const { balacefAccountWbtc } = BalacefAccountWbtc();
  const [currentRoundd, setCurrentRoundd] = useState(null);
  const [copyOfPrice, setCopyOfPrice] = useState(null);
  const [priceCheck, setPriceCheck] = useState(false);
  const web3 = useWeb3();
  // let now = Date.now();
  const { ethPrice } = EthPrice();
  // const { linkPrice } = LinkPrice();
  // const { uniPrice } = UniPrice();
  // const { wbtcPrice } = WbtcPrice();
  const [inputFeild5, setInputField5] = useState(null);
  const [inputFeild, setInputField] = useState(null);
  const [inputFeild1, setInputField1] = useState(null);
  const [ethPricevalue, setEthPrice] = useState(0);
  const [uniPricevalue, setUniPrice] = useState(0);
  const [dopPricevalue, setDopPrice] = useState(0);
  const [linkPricevalue, setlinkPrice] = useState(0);
  const [blanceOfEth, setBlanceOfEth] = useState(0);
  const [date, setDate] = useState(0);
  const [mainTag, setMainTag] = useState("USDT");
  const [mainTag1, setMainTag1] = useState("USDT");
  const { account, chainId } = useWeb3React();
  const [balanceeUsdt, setBalanceeUsdt] = useState(null);
  const [sallowance, setAllowance] = useState(null);
  const [getAllowanceUsdc, setAllowanceUsdc] = useState(null);
  const [getAllowanceWbtc, setAllowanceWbtc] = useState(null);
  const [getAllowanceUsdc1, setAllowanceUsdc1] = useState(null);
  const [getAllowanceWbtc1, setAllowanceWbtc1] = useState(null);
  const [sallowance1, setAllowance1] = useState(null);
  const [currentRount, setCurrentRount] = useState(null);
  const [currentTimer, setCurrentTimer] = useState(null);
  const [timeshow, setTimeshow] = useState(false);

  const [saleCurrentStaus, setSaleCurrentStaus] = useState(false);
  const [saleCurrentStaus1, setSaleCurrentStaus1] = useState(false);
  const [check, setCheck] = useState(false);
  const [amountInUsdt, setAmountInUsdt] = useState(null);
  const [niceName, setNicName] = useState(null);
  // console.log(niceName,'niceName');
  const [tab, setTab] = useState("home");
  const [tagImge, setTagImge] = useState("/assets/usdt.svg");
  const [pepePrice, setPepePrice] = useState(0);
  const [tomiPrice, setTomiPrice] = useState(0);
  const [gemsPrice, setGemsPrice] = useState(0);
  const [gemsBalance, setGemsBalance] = useState(0);
  const [wbtcCurrentPrice, setWbtcCurrentPrice] = useState(null);
  // const [usdcCurrentPrice,setUsdcCurrentPrice]=useState(null)
  const [balaceOfTmi, setBalanceOfTomi] = useState(null);
  const [balaceOfUnii, setBalanceOfUnii] = useState(null);
  const [balaceOfDoppp, setBalanceOfDopp] = useState(null);
  const [balaceOfLinkk, setBalanceOfLinkk] = useState(null);
  const [balaceOfPepee, setBalanceOfPepee] = useState(null);
  const [balaceOfUsdc, setBalanceOfUsdc] = useState(null);
  const [balaceOfWbtc, setBalanceOfWbtc] = useState(null);
  const [tomiAllowance, setTomiAllwance] = useState(null);
  const [gemsAllowance, setGemsAllwance] = useState(null);
  const [uniAllowance, setUniAllwance] = useState(null);
  const [linkAllowance, setLinkAllwance] = useState(null);
  const [dopAllowance, setDopAllwance] = useState(null);
  const [dopAllowance1, setDopAllwance1] = useState(null);
  const [pepeAllowance, setPepeAllwance] = useState(null);
  const [tomiAllowance1, setTomiAllwance1] = useState(null);
  const [percent, setPercet] = useState(0);
  const [stakeIndex, setStakeIndux] = useState([]);
  const [stakedAmount, setStakedAmount] = useState(0);
  const [multiplyPercentNumbere, setMultiplyPercentNumbere] = useState(0);
  const [discountedPriceee, setDiscountedPriceee] = useState(0);
  const [ethValueCalcualte, setethValueCalcualte] = useState(null);
  const [stakeEndTime1, setStakeEndTime1] = useState([]);
  const [stakingData1, setStakingData1] = useState({});
  const [allowedTokens, setAllowedTokens] = useState([]);
  const [cheked3, setCheked3] = useState(false);
  const [cheked4, setCheked4] = useState(false);

  const fetchAllowedTokens = async () => {
    try {
      const response = await axios.get(
        `${API_URL}tokens/allowed?privateSale=${Presale?.apiTag}`,
      );

      if (response?.data?.data) {
        const normalizedTokens = response.data.data.map((token) => {
          if (token.symbol === "USD₮0") {
            return {
              ...token,
              symbol: "USDT",
              name: "Tether USD",
            };
          }
          return token;
        });

        setAllowedTokens(normalizedTokens);
        console.log("allowed tokens", normalizedTokens);
      }
    } catch (error) {
      console.log("fetch allowed tokens error::", error);
    }
  };

  const [show2insurance1, setShow2Insurance1] = useState(false);
  const handleClose2Insurance1 = () => {
    setShow2Insurance1(false);
  };
  const handleClose2Insurance12 = () => {
    // setInsuranceCheck(true);
    setCheckBoxx(true);
    setShow2Insurance1(false);
  };
  const handleShow2Insurance1 = () => {
    setShow2Insurance1(true);
  };
  // const handleClose2Insurance1 = () => setShow2Insurance1(true);

  // const [limitObj, setLimitObj] = useState(null)
  // const [limitObjperc, setLimitObjperc] = useState(null)
  // const [gaugePosition,setGaugePosition] =useState(null);
  // console.log( stakedAmount,discountedPriceee,multiplyPercentNumbere,' Additional Tokens');

  const [show0, setShow0] = useState(false);

  const handleClos0 = async () => {
    setShow0(false);
    if (inputFeild && inputFeild1) {
      if (chainId !== parseInt(CHAIN)) {
        let ss = await setupNetwork();
        if (ss) {
          confirm();
        }
      } else {
        confirm();
      }
    }
  };
  const handleShow0 = () => setShow0(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => {
    setShow5(false);
    window.location.reload();
  };
  const handleShow5 = () => setShow5(true);

  useEffect(() => {
    // capHandler()

    if (web3) {
      firstTimeData();
      firstTimeData11();
      saleStatusss();
      alowence();
      // getGemsPrice();
      fetchAllowedTokens();
      // uniPriceHandler();
      // linkPriceHnadler();
      // dopPriceHandler();
      // getPepePrice();
      // getTomiPrice();
      // getWbtcCurrentPrice();
    }
    if (account) {
      setStakeEndTime1([]);
      balaceOf();
      firstTimeData1();
      // balancerOfGems();
      balancerOfUsdc();
      // fetchStakingData();
      // fetchStakingData1();
      // getGemsStakedAmount();
      // balancerOftomi();
      // balancerOfPepe();
      // balancerOfUni();
      // balancerOfDop();
      // balancerOfLink();
      // balancerOfWbtc();
      // StakeIndec()
    } else {
      setBalanceeUsdt(null);
      setBlanceOfEth(null);
      setBalanceOfUsdc(null);
      setGemsBalance(null);
      setStakeEndTime1([]);
      // setBalanceOfTomi(null);
      // setBalanceOfUnii(null);
      // setBalanceOfDopp(null);
      // setBalanceOfLinkk(null);
      // setBalanceOfPepee(null);
      // setBalanceOfWbtc(null);
    }
  }, [account, chainId, web3]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     firstTimeData();
  //     firstTimeData1();
  //   }, 30000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [account]);

  // console.log(sallowance,'sajad',inputFeild);

  const saleStatusss = async () => {
    try {
      let b = await saleStatus();

      // let b1 = await saleStatus1();
      if (b) {
        console.log(b, "noooor imad");
        // setCurrentRoundd(b)
        // roundData(b)
        setSaleCurrentStaus(b);
        // setSaleCurrentStaus1(b1);
      }
    } catch (err) {
      console.log(err.message, "noooor imad");
    }
  };

  const firstTimeData = async () => {
    setLoarder1(true);
    try {
      let b;
      b = await cuurentRound();
      setRound(b);
      let price = 0;
      if (b) {
        if (b == 1) {
          // setMultiplyPercentNumbere(0.2);
          price = 0.2;
        } else {
          // setMultiplyPercentNumbere(0.07);
          price = 0.07;
        }
        // console.log(b, "cccccccc");
        // setCurrentRoundd(b)
        roundData(b, price);
      }
    } catch (err) {
      console.log(err.message, "nooor");
      setLoarder1(false);
    }
  };
  // console.log(ethPricevalue,'ethPricevalue');
  const firstTimeData11 = async () => {
    try {
      console.log("firstTimeData11 called");
      let a = await ethPrice();
      console.log(a, "AAA ethPrice");
      if (a) {
        setEthPrice(a);
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  // const uniPriceHandler = async () => {
  //   try {
  //     let a = await uniPrice();
  //     if (a) {
  //     setUniPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message,'aaa');
  //   }
  // };
  // const uniPriceHandler = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/uni-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       let qw = response?.data?.data;
  //       // setPepePrice(qw)
  //       setUniPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const dopPriceHandler = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/dop-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       let qw = response?.data?.data;
  //       // setPepePrice(qw)
  //       setDopPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const linkPriceHnadler = async () => {
  //   try {
  //     let a = await linkPrice();
  //     if (a) {
  //       setlinkPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };
  // const getPepePrice = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/pepe-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       // console.log(response,'response');
  //       let qw = response?.data?.data;
  //       setPepePrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };
  // const getTomiPrice = async () => {
  //   try {
  //     const config = {
  //       method: "get",
  //       url: `${API_URL}users/tomi-price`,
  //     };
  //     const postApiRes = await axios(config).then(function (response) {
  //       // console.log(response,'response');
  //       let qw = response?.data?.data;
  //       setTomiPrice(qw);
  //     });
  //   } catch (error) {
  //     console.log("coin market cap error::", error);
  //   }
  // };

  const getGemsPrice = async () => {
    try {
      const config = {
        method: "get",
        url: `${API_URL}users/gems-price`,
      };
      const postApiRes = await axios(config).then(function (response) {
        // console.log(response,'response');
        let qw = response?.data?.data;
        setGemsPrice(qw);
      });
    } catch (error) {
      console.log("coin market cap error::", error);
    }
  };

  const firstTimeData1 = async () => {
    try {
      var balance = await web3.eth.getBalance(account);
      setBlanceOfEth(balance / 10 ** 18);
      console.log("eth balance", balance, balance / 10 ** 18);
    } catch (err) {
      console.log(err.message);
    }
  };

  // const getWbtcCurrentPrice = async () => {
  //   try {
  //     let a = await wbtcPrice();
  //     if (a) {
  //       // console.log(a,'aaa');
  //       setWbtcCurrentPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  const [show1, setShow1] = useState(false);
  const handleClose = () => {
    setInputField("");
    setInputField1("");
    setMyInTotlaPurchasess(0);
    setMyPsTotlaPurchasess(0);
    setShow1(false);
  };
  const handleShow = () => setShow1(true);
  const changeTag = () => {
    if (mainTag === "ETH") {
      setMainTag("USDT");
      setMainTag1("ETH");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      // }
    } else {
      setMainTag("ETH");
      setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    }
  };
  const changeTag1 = (e) => {
    if (e === "ETH") {
      discoundedPriceee(currentRoundd, Environment.eth);
      setMainTag("ETH");
      setTagImge("/assets/eth-icon.svg");
      // setMainTag1("ETH");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      // }
    } else if (e == "USDT") {
      discoundedPriceee(currentRoundd, Environment.busd);
      setMainTag("USDT");
      setTagImge("/assets/usdt.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "USDC") {
      discoundedPriceee(currentRoundd, Environment.usdc);
      setMainTag("USDC");
      setTagImge("/assets/usdc.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    }
    //  else if (e == "WBTC") {
    //   discoundedPriceee(currentRoundd, Environment.wbtc);
    //   setMainTag("WBTC");
    //   setTagImge("/assets/wbtc.svg");
    //   // setMainTag1("USDT");
    //   setInputField1("");
    //   setInputField("");
    //   setMyInTotlaPurchasess(0);
    //   setMyPsTotlaPurchasess(0);
    // } else if (e == "PEPE") {
    //   discoundedPriceee(currentRoundd, Environment.pepe);
    //   setMainTag("PEPE");
    //   setTagImge("/assets/pepe.svg");
    //   // setMainTag1("USDT");
    //   setInputField1("");
    //   setInputField("");
    //   setMyInTotlaPurchasess(0);
    //   setMyPsTotlaPurchasess(0);
    // } else if (e == "DOP") {
    //   discoundedPriceee(currentRoundd, Environment.dop);
    //   setMainTag("DOP");
    //   setTagImge("/assets/dop.svg");
    //   // setMainTag1("USDT");
    //   setInputField1("");
    //   setInputField("");
    //   setMyInTotlaPurchasess(0);
    //   setMyPsTotlaPurchasess(0);
    // } else if (e == "UNI") {
    //   discoundedPriceee(currentRoundd, Environment.unisape);
    //   setMainTag("UNI");
    //   setTagImge("/assets/uniswap.svg");
    //   // setMainTag1("USDT");
    //   setInputField1("");
    //   setInputField("");
    //   setMyInTotlaPurchasess(0);
    //   setMyPsTotlaPurchasess(0);
    // } else if (e == "LINK") {
    //   discoundedPriceee(currentRoundd, Environment.link);
    //   setMainTag("LINK");
    //   setTagImge("/assets/link.svg");
    //   // setMainTag1("USDT");
    //   setInputField1("");
    //   setInputField("");
    //   setMyInTotlaPurchasess(0);
    //   setMyPsTotlaPurchasess(0);
    // } else if (e == "TOMI") {
    //   discoundedPriceee(currentRoundd, Environment.tomi);
    //   setMainTag("TOMI");
    //   setTagImge("/assets/tomi-icon-drop.svg");
    //   // setMainTag1("USDT");
    //   setInputField1("");
    //   setInputField("");
    //   setMyInTotlaPurchasess(0);
    //   setMyPsTotlaPurchasess(0);
    // } else {
    //   discoundedPriceee(currentRoundd, Environment.gems);
    //   setMainTag("GEMS");
    //   setTagImge("/assets/newgemslogosvg.svg");
    //   // setMainTag1("USDT");
    //   setInputField1("");
    //   setInputField("");
    //   setMyInTotlaPurchasess(0);
    //   setMyPsTotlaPurchasess(0);
    // }
  };
  const inputField1Handler = (e) => {
    setAmountInUsdt(0);
    let value = e.target.value;
    if (mainTag === "ETH") {
      if (value) {
        console.log(value, ethPricevalue, price);
        let amount = parseFloat((ethPricevalue * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
          console.log(amount1, "amountt");
        } else {
          amount1 = 0.0;
        }
        console.log(price, "Price");
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(ethPricevalue * value));
        setInputField(value);
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        let aa = (ethPricevalue * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
        // console.log(cc.toFixed,aa,vv,discountedPriceee, 'ccccc');

        // (parseFloat(inputFeild) * parseFloat(ethPricevalue) / parseFloat(discountedPriceee))- (parseFloat(inputFeild1))
        // ?.toFixed(2)
      } else {
        setInputField1("");
        setInputField("");
        setethValueCalcualte(0);
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "USDT") {
      if (value) {
        let amount = parseFloat(value / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setInputField(value);
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setAmountInUsdt(parseFloat(value));

        let aa = value;
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setethValueCalcualte(0);
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "USDC") {
      if (value) {
        let amount = parseFloat(value / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);
        setAmountInUsdt(parseFloat(value));
        let aa = value;
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
        setethValueCalcualte(0);
      }
    } else if (mainTag === "WBTC") {
      if (value) {
        let amount = parseFloat((wbtcCurrentPrice * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(wbtcCurrentPrice * value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);
        let aa = (wbtcCurrentPrice * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "UNI") {
      if (value) {
        let amount = parseFloat((uniPricevalue * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }

        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(uniPricevalue * value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);

        let aa = (uniPricevalue * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "LINK") {
      if (value) {
        let amount = parseFloat((linkPricevalue * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        // console.log('aasas',linkPricevalue,value,price);
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(linkPricevalue * value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);

        let aa = (linkPricevalue * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "DOP") {
      if (value) {
        let amount = parseFloat((dopPricevalue * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        // console.log('aasas',linkPricevalue,value,price);
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(dopPricevalue * value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);

        let aa = (dopPricevalue * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "PEPE") {
      if (value) {
        let amount = parseFloat((pepePrice * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setAmountInUsdt(parseFloat(pepePrice * value));
        setInputField(value);

        let aa = (pepePrice * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "TOMI") {
      if (value) {
        let amount = parseFloat((tomiPrice * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setAmountInUsdt(parseFloat(tomiPrice * value));
        setInputField(value);
        let aa = (tomiPrice * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else {
      if (value) {
        let amount = parseFloat((gemsPrice * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setAmountInUsdt(parseFloat(gemsPrice * value));
        setInputField(value);
        let aa = (gemsPrice * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    }
  };
  const inputField1Handler1 = (e) => {
    let value = e.target.value;
    if (mainTag === "ETH") {
      if (value) {
        let amount = parseFloat((value * price) / ethPricevalue).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
        console.log(amount, amount1, value, "amount, amount1, value");

        // }
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "USDT") {
      if (value) {
        let amount = parseFloat(value * price).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(value);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "USDC") {
      if (value) {
        let amount = parseFloat(value * price).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(value);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "WBTC") {
      if (value) {
        let amount = parseFloat((value * price) / wbtcCurrentPrice).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "UNI") {
      if (value) {
        let amount = parseFloat((value * price) / uniPricevalue).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "LINK") {
      if (value) {
        let amount = parseFloat((value * price) / linkPricevalue).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "DOP") {
      if (value) {
        let amount = parseFloat((value * price) / dopPricevalue).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "PEPE") {
      if (value) {
        let amount = parseFloat((value * price) / pepePrice).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setInputField1(parseFloat(value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

        // }
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "TOMI") {
      if (value) {
        let amount = parseFloat((value * price) / tomiPrice).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setInputField1(parseFloat(value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

        // }
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else {
      if (value) {
        let amount = parseFloat((value * price) / gemsPrice).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setInputField1(parseFloat(value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

        // }
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    }
  };
  const balaceOf = async () => {
    try {
      let balace = await balacefAccount(account);
      if (balace) {
        console.log(balace, "Balance");
        setBalanceeUsdt(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // const balancerOftomi = async () => {
  //   try {
  //     let balace = await balacefAccountTomi(account);
  //     if (balace) {
  //       console.log(balace, "tomi erre");
  //       setBalanceOfTomi(balace);
  //     }
  //   } catch (err) {
  //     console.log(err, "tomi erre");
  //   }
  // };
  const balancerOfGems = async () => {
    try {
      let balace = await balacefAccountGems(account);
      if (balace) {
        console.log(balace, "gems balance");
        setGemsBalance(balace);
      }
    } catch (err) {
      console.log(err, "tomi erre");
    }
  };
  // const balancerOfPepe = async () => {
  //   try {
  //     let balace = await balacefAccountPepe(account);
  //     if (balace) {
  //       setBalanceOfPepee(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfUni = async () => {
  //   try {
  //     let balace = await balacefAccountUni(account);
  //     if (balace) {
  //       setBalanceOfUnii(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfDop = async () => {
  //   try {
  //     let balace = await balacefAccountDop(account);
  //     if (balace) {
  //       setBalanceOfDopp(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const balancerOfLink = async () => {
  //   try {
  //     let balace = await balacefAccountLink(account);
  //     if (balace) {
  //       setBalanceOfLinkk(balace);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const balancerOfUsdc = async () => {
    try {
      let balace = await balacefAccountUsdc(account);
      if (balace) {
        setBalanceOfUsdc(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // const balancerOfWbtc = async () => {
  //   try {
  //     let balace = await balacefAccountWbtc(account);
  //     if (balace) {
  //       setBalanceOfWbtc(balace);
  //     }
  //   } catch (err) {
  //     console.log(err, "sdsdsdvcv");
  //   }
  // };
  const alowence = async () => {
    try {
      // let insirance = await insurancePercentage();
      // setInsurancePer(insirance / 100);

      // let w134sr = await allowanceGems1();

      // console.log(w134sr, "Gems")
      // setGemsAllwance1(w134sr);
      // let w134s = await allowanceDop1();
      // setDopAllwance1(w134s);
      // let was = await allowanceGems();
      // setGemsAllwance(was);
      let r = await allowanceTpl();
      setAllowance(r);
      let usdcc = await allowanceUsdc();
      setAllowanceUsdc(usdcc);
      // let wbtcc = await allowanceWbtc();
      // setAllowanceWbtc(wbtcc);
      // let w11 = await allowanceLink();
      // setLinkAllwance(w11);
      // let w134 = await allowanceDop();
      // setDopAllwance(w134);
      // let w22 = await allowancePepe();
      // setPepeAllwance(w22);
      // let w33 = await allowanceUniswape();
      // setUniAllwance(w33);
      // let w = await allowanceTomi();
      // setTomiAllwance(w);
      // let r1 = await allowanceTpl1();
      // setAllowance1(r1);
      // let da = await allowanceTomi1();
      // setTomiAllwance1(da);

      // let usdcc1 = await allowanceUsdc1();
      // setAllowanceUsdc1(usdcc1);
      // let wbtcc1 = await allowanceWbtc1();
      // setAllowanceWbtc1(wbtcc1);
    } catch (err) {
      console.log(err, "nooooer23");
    }
  };

  // const callRecordEventTrxTrigger = async (metaData) => {
  //   await recordEvent(metaData);
  // };

  // const callRecordEventTrxStatus = async (metaData) => {
  //   await recordEvent(metaData);
  // };

  const handlerPop = async () => {
    if (inputFeild && inputFeild1) {
      if (chainId !== parseInt(CHAIN)) {
        await setupNetwork(CHAIN);
      }
      confirm();
    }
  };

  const confirm = async () => {
    setLoarder(true);
    let postApiRes = "";
    var config = "";
    confirmBuyBefore();
    if (role === "institution") {
      if (mainTag == "ETH") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "USDC") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "WBTC") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "USDT") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "TOMI") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else if (mainTag == "DOP") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      } else {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/screx`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: Presale?.apiTag,
          },
        };
      }

      postApiRes = await axios(config)
        .then(function (response) {
          return response?.data?.data;
        })
        .catch(function (error) {
          toast.error(error?.response?.data.message);
        });
    } else {
      if (mainTag == "TOMI") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "TOMI",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "ETH") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "ETH",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "WBTC") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "WBTC",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "USDC") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "USDC",
            email: email,
            // isInsured: checkBoxx,
            type: "TOKEN",
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "UNI") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "UNI",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "LINK") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "LINK",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "PEPE") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "PEPE",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "DOP") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "DOP",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag === "USDT") {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "USDT",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else {
        config = {
          method: "post",
          url: `${API_URL + Presale?.apiUrl}`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "GEMS",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      }

      postApiRes = await axios(config)
        .then(function (response) {
          return response?.data?.data;
        })
        .catch(function (error) {
          toast.error(error?.response?.data.message);
        });
    }

    let metaData = {};

    if (role === "institution") {
      if (mainTag === "ETH") {
        try {
          if (postApiRes) {
            if (saleCurrentStaus1) {
              let b = blanceOfEth - parseFloat(inputFeild);
              let x = await purchaseEth1(
                parseFloat(inputFeild1),
                parseFloat(inputFeild),
                postApiRes,
                inputFeild5,
                b,
              );
              if (x) {
                confirmInst(x, postApiRes);
                setLoarder(false);
                firstTimeData();
                firstTimeData11();
                firstTimeData1();
                balaceOf();
                alowence();
                // balaceOf1();
                // capHandler()
                handleShow();
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else if (mainTag === "USDT") {
        if (sallowance1 === 0) {
          try {
            let z = await approveTpl1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseUsdt1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > sallowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res = await approveTpl1(0, account);
                  if (res) {
                    let res11 = await approveTpl1(10000000, account);

                    if (res11) {
                      let q = await purchaseUsdt1(
                        inputFeild,
                        postApiRes,
                        inputFeild5,
                        blanceOfEth,
                        parseFloat(inputFeild1),
                      );
                      if (q) {
                        confirmInst(q, postApiRes);
                        setLoarder(false);
                        firstTimeData();
                        firstTimeData11();
                        firstTimeData1();
                        balaceOf();
                        alowence();
                        // balaceOf1();
                        // capHandler()
                        handleShow();
                      }
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseUsdt1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "WBTC") {
        if (getAllowanceWbtc1 === 0) {
          try {
            let z = await approveTplwbtc1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseWbtc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceWbtc1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTplwbtc1(10000000, account);

                  if (res11) {
                    let q = await purchaseWbtc1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseWbtc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "USDC") {
        if (getAllowanceUsdc1 === 0) {
          try {
            let z = await approveTplUsdc1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseUsdc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceUsdc1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTplUsdc1(10000000, account);

                  if (res11) {
                    let q = await purchaseUsdc1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseUsdc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "TOMI") {
        if (tomiAllowance1 === 0) {
          try {
            let z = await approveTomi1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseTomi1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > tomiAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTomi1(10000000, account);

                  if (res11) {
                    let q = await purchaseTomi1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseTomi1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "DOP") {
        if (dopAllowance1 === 0) {
          try {
            let z = await approveDop1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseDop1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > dopAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveDop1(10000000, account);

                  if (res11) {
                    let q = await purchaseDop1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseDop1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else {
        if (gemsAllowance1 === 0) {
          try {
            let z = await approveGems1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseGems1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > gemsAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveGems1(10000000, account);

                  if (res11) {
                    let q = await purchaseGems1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseGems1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      }
    } else {
      if (mainTag === "ETH") {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              let b = blanceOfEth - parseFloat(inputFeild);
              // console.log(b,'balance',gasPrice/10**9);
              let x = await purchaseEth(
                parseFloat(inputFeild1),
                parseFloat(inputFeild),
                postApiRes,
                currentRoundd,
                b,
                stakeIndex,
                checkBoxx,
                insurancePer,
              );
              if (x) {
                if (checkBoxx) {
                  confirmBuy12(x, postApiRes);
                } else {
                  confirmBuy(x, postApiRes);
                }

                // metaData = {
                //   transactionStatus: [
                //     {
                //       executed: true,
                //       blockchainSuccess: true,
                //       ex: "none",
                //       transactionHash: x?.transactionHash,
                //     },
                //   ],
                // };

                // await callRecordEventTrxStatus(metaData);

                setLoarder(false);
                firstTimeData();
                firstTimeData11();
                firstTimeData1();
                balaceOf();
                alowence();
                // capHandler()
                // balaceOf1();
                handleShow();
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err.message, "errr");

          // metaData = {
          //   transactionStatus: [
          //     {
          //       executed: false,
          //       blockchainSuccess: false,
          //       ex: err.message,
          //       transactionHash: "none",
          //     },
          //   ],
          // };

          // await callRecordEventTrxStatus(metaData);

          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else if (mainTag === "USDT") {
        console.log(sallowance, "sallowance usdt");
        if (sallowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTpl(10000000, account);
                if (z) {
                  let q = await purchaseUsdt(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    // metaData = {
                    //   transactionStatus: [
                    //     {
                    //       executed: true,
                    //       blockchainSuccess: true,
                    //       ex: "none",
                    //       transactionHash: q?.transactionHash,
                    //     },
                    //   ],
                    // };

                    // await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();

            // metaData = {
            //   transactionStatus: [
            //     {
            //       executed: false,
            //       blockchainSuccess: false,
            //       ex: err.message,
            //       transactionHash: "none",
            //     },
            //   ],
            // };

            // await callRecordEventTrxStatus(metaData);

            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > sallowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res = await approveTpl(0, account);
                  if (res) {
                    let res11 = await approveTpl(10000000, account);

                    if (res11) {
                      let q = await purchaseUsdt(
                        inputFeild,
                        postApiRes,
                        currentRoundd,
                        blanceOfEth,
                        parseFloat(inputFeild1),
                        stakeIndex,
                        insurancePer,
                      );
                      if (q) {
                        if (checkBoxx) {
                          confirmBuy12(q, postApiRes);
                        } else {
                          confirmBuy(q, postApiRes);
                        }

                        // metaData = {
                        //   transactionStatus: [
                        //     {
                        //       executed: true,
                        //       blockchainSuccess: true,
                        //       ex: "none",
                        //       transactionHash: q?.transactionHash,
                        //     },
                        //   ],
                        // };

                        // await callRecordEventTrxStatus(metaData);

                        setLoarder(false);
                        firstTimeData();
                        firstTimeData11();
                        firstTimeData1();
                        balaceOf();
                        alowence();
                        // capHandler()
                        // balaceOf1();
                        handleShow();
                      }
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUsdt(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    // metaData = {
                    //   transactionStatus: [
                    //     {
                    //       executed: true,
                    //       blockchainSuccess: true,
                    //       ex: "none",
                    //       transactionHash: q?.transactionHash,
                    //     },
                    //   ],
                    // };

                    // await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");

            // metaData = {
            //   transactionStatus: [
            //     {
            //       executed: false,
            //       blockchainSuccess: false,
            //       ex: err.message,
            //       transactionHash: "none",
            //     },
            //   ],
            // };

            // await callRecordEventTrxStatus(metaData);

            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "USDC") {
        console.log(getAllowanceUsdc, "sallowance");
        if (getAllowanceUsdc === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTplUsdc(10000000, account);
                if (z) {
                  let q = await purchaseUsdc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    // metaData = {
                    //   transactionStatus: [
                    //     {
                    //       executed: true,
                    //       blockchainSuccess: true,
                    //       ex: "none",
                    //       transactionHash: q?.transactionHash,
                    //     },
                    //   ],
                    // };

                    // await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");

            // metaData = {
            //   transactionStatus: [
            //     {
            //       executed: false,
            //       blockchainSuccess: false,
            //       ex: err.message,
            //       transactionHash: "none",
            //     },
            //   ],
            // };

            // await callRecordEventTrxStatus(metaData);

            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceUsdc) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTplUsdc(10000000, account);

                  if (res11) {
                    let q = await purchaseUsdc(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }

                      // metaData = {
                      //   transactionStatus: [
                      //     {
                      //       executed: true,
                      //       blockchainSuccess: true,
                      //       ex: "none",
                      //       transactionHash: q?.transactionHash,
                      //     },
                      //   ],
                      // };

                      // await callRecordEventTrxStatus(metaData);

                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUsdc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    // metaData = {
                    //   transactionStatus: [
                    //     {
                    //       executed: true,
                    //       blockchainSuccess: true,
                    //       ex: "none",
                    //       transactionHash: q?.transactionHash,
                    //     },
                    //   ],
                    // };

                    // await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");

            // metaData = {
            //   transactionStatus: [
            //     {
            //       executed: false,
            //       blockchainSuccess: false,
            //       ex: err.message,
            //       transactionHash: "none",
            //     },
            //   ],
            // };

            // await callRecordEventTrxStatus(metaData);

            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "WBTC") {
        if (getAllowanceWbtc === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                console.log(getAllowanceWbtc, mainTag, "sallowance");
                let z = await approveTplwbtc(1000000, account);
                if (z) {
                  let q = await purchaseWbtc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    // metaData = {
                    //   transactionStatus: [
                    //     {
                    //       executed: true,
                    //       blockchainSuccess: true,
                    //       ex: "none",
                    //       transactionHash: q?.transactionHash,
                    //     },
                    //   ],
                    // };

                    // await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceWbtc) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTplwbtc(1000000, account);

                  if (res11) {
                    let q = await purchaseWbtc(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }

                      // metaData = {
                      //   transactionStatus: [
                      //     {
                      //       executed: true,
                      //       blockchainSuccess: true,
                      //       ex: "none",
                      //       transactionHash: q?.transactionHash,
                      //     },
                      //   ],
                      // };

                      // await callRecordEventTrxStatus(metaData);

                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseWbtc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    // metaData = {
                    //   transactionStatus: [
                    //     {
                    //       executed: true,
                    //       blockchainSuccess: true,
                    //       ex: "none",
                    //       transactionHash: q?.transactionHash,
                    //     },
                    //   ],
                    // };

                    // await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "LINK") {
        console.log(mainTag, linkAllowance, "sdsdsds");
        if (linkAllowance === 0) {
          try {
            let z = await approveLink(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseLink(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > linkAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveLink(10000000, account);

                  if (res11) {
                    let q = await purchaseLink(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseLink(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "PEPE") {
        if (pepeAllowance === 0) {
          try {
            let z = await approvePepe(1000000000000000, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchasePepe(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > pepeAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approvePepe(10000000000000000, account);

                  if (res11) {
                    let q = await purchasePepe(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchasePepe(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "DOP") {
        if (dopAllowance === 0) {
          try {
            let z = await approveDop(1000000000000000, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseDop(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > dopAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveDop(10000000000000000, account);

                  if (res11) {
                    let q = await purchaseDop(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseDop(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "UNI") {
        if (uniAllowance === 0) {
          try {
            let z = await approveUnisawape(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseUniswape(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > uniAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveUnisawape(10000000, account);

                  if (res11) {
                    let q = await purchaseUniswape(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUniswape(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "TOMI") {
        if (tomiAllowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTomi(10000000, account);
                if (z) {
                  let q = await purchaseTomi(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > tomiAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTomi(10000000, account);

                  if (res11) {
                    let q = await purchaseTomi(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseTomi(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else {
        if (gemsAllowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveGems(10000000, account);
                if (z) {
                  let q = await purchaseGems(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    // metaData = {
                    //   transactionStatus: [
                    //     {
                    //       executed: true,
                    //       blockchainSuccess: true,
                    //       ex: "none",
                    //       transactionHash: q?.transactionHash,
                    //     },
                    //   ],
                    // };

                    // await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");

            // metaData = {
            //   transactionStatus: [
            //     {
            //       executed: false,
            //       blockchainSuccess: false,
            //       ex: err.message,
            //       transactionHash: "none",
            //     },
            //   ],
            // };

            // await callRecordEventTrxStatus(metaData);

            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > gemsAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveGems(10000000, account);

                  if (res11) {
                    let q = await purchaseGems(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer,
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }

                      // metaData = {
                      //   transactionStatus: [
                      //     {
                      //       executed: true,
                      //       blockchainSuccess: true,
                      //       ex: "none",
                      //       transactionHash: q?.transactionHash,
                      //     },
                      //   ],
                      // };

                      // await callRecordEventTrxStatus(metaData);

                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseGems(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer,
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }

                    // metaData = {
                    //   transactionStatus: [
                    //     {
                    //       executed: true,
                    //       blockchainSuccess: true,
                    //       ex: "none",
                    //       transactionHash: q?.transactionHash,
                    //     },
                    //   ],
                    // };

                    // await callRecordEventTrxStatus(metaData);

                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");

            // metaData = {
            //   transactionStatus: [
            //     {
            //       executed: false,
            //       blockchainSuccess: false,
            //       ex: err.message,
            //       transactionHash: "none",
            //     },
            //   ],
            // };

            // await callRecordEventTrxStatus(metaData);

            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      }
    }
  };

  const userLogin1 = async (e) => {
    // setLoarder(true);
    discoundedPriceee(e, Environment?.eth);
    let b = tab === "home" ? "sale-rounds/users" : "sale-rounds/users-nft";
    await axios
      .get(API_URL + b)
      .then(async (res) => {
        // setLoarder(false);
        let a = res.data.data;
        // console.log(a, 'aaaa', e);
        a.map((i) => {
          if (e == i?.round && i.privateSale == Presale?.apiTag) {
            setNicName(i.round);
          }
        });

        setTimeout(() => {
          // console.log("Delayed for 1 second.");
          setLoarder1(false);
        }, "1000");
        // calucation(res.data.data)
        // console.log(res.data.data,'res.data.data');
      })
      .catch((err) => {
        console.log(err, "err");
        setLoarder1(false);
        // setLoarder(false);
      });
  };

  useEffect(() => {
    // console.log('usefffef',email,code);
    if (!email || !code) {
      history.push("/");
    }
  }, [startTime11]);
  useEffect(() => {
    //  console.log(chainId,'chainIdchainId');
    if (account) {
      if (chainId !== parseInt(CHAIN)) {
        setupNetwork(CHAIN);
      }
    }
  }, [account, chainId]);

  // const calucation = (e, pppp) => {
  //   let dummy = [];
  //   let a = "";
  //   let indexx = "";
  //   let aaa = e.map((i, index) => {
  //     let tempLockedLending2 = "";
  //     if (
  //       currentTime > parseInt(i.startTime) &&
  //       currentTime < parseInt(i.endTime)
  //     ) {
  //       a = i;
  //       indexx = index + 1;
  //       let deff = currentTime - parseInt(i.startTime);
  //       tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
  //       dummy.push(tempLockedLending2);
  //     } else {
  //       let deff = currentTime - parseInt(i.startTime);
  //       tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
  //       dummy.push(tempLockedLending2);
  //     }
  //   });
  //   if (a) {
  //     setPrice(a?.price / 10 ** 18);
  //     let b = a?.price / 10 ** 18;
  //     let disprice = indexx == 1 ? 0.2 : 0.07;
  //     setMultiplyPercentNumbere(indexx == 1 ? 0.2 : 0.07);
  //     let c = b * disprice;
  //     let v = b - c;
  //     setDiscountedPriceee(v);
  //     setCopyOfPrice(a?.price / 10 ** 18);
  //     setCurrentRount(a);
  //     setCurrentRoundd(indexx);
  //     localStorage.setItem("currentRunningRound", indexx);
  //     userLogin1(indexx + 2);
  //     // setPrice(value?.price/10**18)
  //   } else if (dummy?.length > 0) {
  //     dummy.sort((a, b) => {
  //       return a?.diffrence - b?.diffrence;
  //     });
  //     console.log(dummy, "dummydummy");
  //     setCurrentRount(dummy[0]);
  //     setCurrentRoundd(dummy[0]?.currentround);
  //     localStorage.setItem("currentRunningRound", dummy[0]?.currentround);
  //     setPrice(dummy[0]?.price / 10 ** 18);
  //     let b = dummy[0]?.price / 10 ** 18;
  //     let disprice = dummy[0]?.currentround == 1 ? 0.2 : 0.07;
  //     let c = b * disprice;
  //     let v = b - c;
  //     setMultiplyPercentNumbere(dummy[0]?.currentround == 1 ? 0.2 : 0.07);
  //     setDiscountedPriceee(v);
  //     setCopyOfPrice(dummy[0]?.price / 10 ** 18);
  //     userLogin1(dummy[0]?.currentround + 2);
  //     // console.log(dummy,'dummy');
  //   }
  //   // console.log(dummy,'new dateee',a);
  //   if (role === "institution") {
  //     setPrice(instiPrice);
  //   }
  // };

  // const roundData = async (e, pppp) => {
  //   // console.log(e, 'ccccccc');
  //   try {
  //     if (parseInt(e) <= 1) {
  //       // console.log("in if noor ", e);
  //       let c = "";
  //       if (tab === "home") {
  //         // console.log(e,'noooor');
  //         c = await timer(e);
  //         // console.log(c,'in timer');
  //       } else {
  //         c = await timerNft(e);
  //       }

  //       if (c) {
  //         setCurrentRount(c);
  //         setPrice(c?.price / 10 ** 18);
  //         let b = c?.price / 10 ** 18;
  //         let discount = e == 1 ? 0.2 : 0.07;
  //         setMultiplyPercentNumbere(e == 1 ? 0.2 : 0.07);
  //         let cc = b * discount;
  //         let v = b - cc;
  //         setDiscountedPriceee(v);
  //         // console.log(e, multiplyPercentNumbere, v, 'ccccccc');
  //         setCopyOfPrice(c?.price / 10 ** 18);
  //         setCurrentRoundd(e);
  //         localStorage.setItem("currentRunningRound", e);
  //         userLogin1(e);
  //         setTimeout(() => {
  //           // console.log("Delayed for 1 second.");
  //           setLoarder1(false);
  //         }, "1000");

  //         // setPrice(c.price/10**18)
  //         // console.log('nooor',c.price);
  //         // setCurrentTimer(c)
  //       }
  //     } else {
  //       let dummy = [];
  //       // console.log(e, 'loooop bahis');
  //       for (let a = 1; a <= e; a++) {
  //         // console.log(a, 'loooop');
  //         let c = "";
  //         if (tab === "home") {
  //           c = await timer(a);
  //           // console.log("noor if  ", c);
  //         } else {
  //           // console.log('noor else  ',c);
  //           c = await timerNft(a);
  //         }
  //         dummy.push(c);
  //       }
  //       // console.log(dummy, 'loooop');
  //       calucation(dummy, pppp);
  //     }
  //   } catch (err) {
  //     console.log(err, "erro in timer");
  //     setLoarder1(false);
  //   }
  // };

  const roundData = async (e, pppp) => {
    try {
      if (parseInt(e) <= 1) {
        // Handle single round case
        const roundInfo = tab === "home" ? await timer(e) : await timerNft(e);

        if (roundInfo) {
          updateRoundState(roundInfo, e);
        }
      } else {
        // Start from current round and go backwards to find active round
        let activeRound = null;
        let roundNumber = null;

        // Check rounds from current (e) down to 1
        for (let i = parseInt(e); i >= 1; i--) {
          const roundInfo = tab === "home" ? await timer(i) : await timerNft(i);

          // Check if this round is currently active
          if (
            currentTime > parseInt(roundInfo.startTime) &&
            currentTime < parseInt(roundInfo.endTime)
          ) {
            activeRound = roundInfo;
            roundNumber = i;
            break; // Found active round, stop searching
          }

          // Store first round for fallback
          if (!activeRound) {
            activeRound = roundInfo;
            roundNumber = i;
          }
        }

        // If no active round found, find the closest one
        if (
          !activeRound ||
          currentTime < parseInt(activeRound.startTime) ||
          currentTime > parseInt(activeRound.endTime)
        ) {
          const allRounds = await fetchAllRounds(e);
          activeRound = findClosestRound(allRounds);
          roundNumber = activeRound.roundNumber;
        }

        updateRoundState(activeRound, roundNumber);
      }
    } catch (err) {
      console.log(err, "error in roundData");
      setLoarder1(false);
    }
  };

  // Helper function to fetch all rounds if needed
  const fetchAllRounds = async (maxRound) => {
    const rounds = [];
    for (let i = 1; i <= maxRound; i++) {
      const roundInfo = tab === "home" ? await timer(i) : await timerNft(i);
      rounds.push({ ...roundInfo, roundNumber: i });
    }
    return rounds;
  };

  // Helper function to find closest round
  const findClosestRound = (rounds) => {
    let closestRound = null;
    let minDiff = Infinity;

    rounds.forEach((round) => {
      const diff = Math.abs(currentTime - parseInt(round.startTime));
      if (diff < minDiff) {
        minDiff = diff;
        closestRound = round;
      }
    });

    return closestRound;
  };

  // Helper function to update state
  const updateRoundState = (roundInfo, roundNumber) => {
    setCurrentRount(roundInfo);
    setCurrentRoundd(roundNumber);
    localStorage.setItem("currentRunningRound", roundNumber);

    const basePrice = roundInfo.price / 10 ** 18;
    const discount = roundNumber == 1 ? 0.2 : 0.07;
    const discountedPrice = basePrice * (1 - discount);

    setPrice(basePrice);
    setCopyOfPrice(basePrice);
    setMultiplyPercentNumbere(discount);
    setDiscountedPriceee(discountedPrice);

    if (role !== "institution") {
      userLogin1(roundNumber);
    } else {
      setPrice(instiPrice);
    }

    setTimeout(() => setLoarder1(false), 1000);
  };

  const inputField1Handler5 = async (e) => {
    var length = e.target.value.split(" ").join("").length;
    setInputField5(e.target.value);
    setCheck(false);
    if (length === 42) {
      let r = web3.utils.isAddress(e.target.value);
      if (r) {
        setCheck(true);
      } else {
        setCheck(false);
      }
    }
  };

  const confirmInst = async (data, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: data?.transactionHash,
        accessCodeRole: role,
        by: account,
        dopPurchased: inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price: price,
        privateSale: Presale?.apiTag,
        isInsured: false,
        recipient: inputFeild5,
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuy12 = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue =
      parseFloat(inputFeild1) + parseInt(ethValueCalcualte?.toFixed(2));
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length > 0) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length > 0) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        recipient: account,
        isInsured: true,
        buyingAmountUsd: amountInUsdt?.toFixed(4),
        insuranceFee: parseFloat(inputFeild * insurancePer)?.toFixed(4),
        insuranceFeeUsd: parseFloat(amountInUsdt * insurancePer)?.toFixed(4),
        totalBuyingAmount: parseFloat(
          parseFloat(inputFeild) + parseFloat(inputFeild * insurancePer),
        )?.toFixed(4),
        totalBuyingAmountUsd: parseFloat(
          parseFloat(amountInUsdt) + parseFloat(amountInUsdt * insurancePer),
        )?.toFixed(4),
      },
    };

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuy = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue =
      parseFloat(inputFeild1) + parseInt(ethValueCalcualte?.toFixed(2));
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuyBefore = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue =
      parseFloat(inputFeild1) + parseInt(ethValueCalcualte?.toFixed(2));
    const config = {
      method: "post",
      url: `${API_URL}emails/temp`,
      data: {
        accessCode: code,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };

    const metaData = {
      purchaseTxn: [
        {
          type: "TOKEN",
          nft: "none",
          amountInvested: parseFloat(inputFeild),
          tokenSelected: mainTag,
          tokensReceived:
            (stakedAmount >= 5555 && stakingData?.length) ||
            moment().isBefore(stakeEndTime1)
              ? nereValue
              : inputFeild1,
          dollarAmount: parseFloat(amountInUsdt)?.toFixed(4),
        },
      ],
    };

    // await callRecordEventTrxTrigger(metaData);

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };

  const tabHandler = (e) => {
    discoundedPriceee(currentRoundd, Environment.eth);
    setMainTag("ETH");
    setTagImge("/assets/eth-icon.svg");
    if (tab == "home") {
      setTab("profile");
    } else {
      setTab("home");
    }
  };
  // console.log(price,'buy price');
  const discoundedPriceee = async (aa, e) => {
    // console.log(a,e,'a,e');
    try {
      let ab = await discountedPrice(aa, e);
      // console.log('buy',ab,copyOfPrice);
      if (role != "institution") {
        if (ab > 0) {
          // console.log('if chala');
          setPrice(ab);
          let b = ab;
          let c = b * multiplyPercentNumbere;
          let v = b - c;
          setDiscountedPriceee(v);
          setPercet(100 * ((copyOfPrice - ab) / copyOfPrice));
          console.log(ab, e, "callll ho raHA ");
          setPriceCheck(true);
        } else {
          if (copyOfPrice) {
            setPriceCheck(false);
            setPrice(copyOfPrice);
            let b = copyOfPrice;
            let c = b * multiplyPercentNumbere;
            let v = b - c;
            setDiscountedPriceee(v);
          }
        }
      } else {
        setPrice(instiPrice);
      }
    } catch (err) {
      console.log(err, "discoundedPrice err");
    }
  };

  const witterHandler = () => {
    // const weChatShareUrl = "https://x.com/Gems_VIP_";
    // // Open the WeChat share link in a new window
    // window.open(weChatShareUrl, "_blank");
    // window.location.reload();
  };

  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleTooltipMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleTooltipMouseLeave = () => {
    setShowTooltip(false);
  };

  // useEffect(() => {
  //   setInterval(() => {
  //     fetchStakingData()
  //   }, 30000);
  // }, [])
  // const apiCheck = async (e) => {

  //   const data = {
  //     accessCode: code,
  //   };
  //   await axios
  //     .post(API_URL + "users/verify-code", data)
  //     .then(async (res) => {
  //       setLimitObj(res.data.data.limit)
  //       let a = parseInt(res.data.data.limit.buyingLimit)
  //       let b = parseInt(res.data.data.limit.saleCount)
  //       let c = (b / a) * 100
  //       const clampedValue = Math.min(100, Math.max(0, c));
  //       setGaugePosition(`${clampedValue}%`)
  //       setLimitObjperc(c)
  //       let dd = JSON.stringify(res.data.data.limit)
  //       localStorage?.setItem("oobjj", dd);
  //     })
  //     .catch((err) => {
  //       console.log(err, "err");

  //     });
  // }

  const fetchStakingData = async () => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        stakeds(where: {isClaimed: false, staker: "${account}"}) {
          stakerStakeIndex
          transactionHash
          stakeEndTime
          staker
          isClaimed
          id
          blockTimestamp
          blockNumber
          amount
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: Environment.gemsLockingGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        console.log(response, "response");

        const resData = response?.data?.data?.stakeds;
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          // console.log(a, 'mainn1');
          let bcc = a?.sort();
          setStakeIndux(bcc);
          setStakingData(resData);
          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(
            resData[resData?.length - 1]?.stakeEndTime,
          );
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
          if (!endTimeStamp.isValid()) {
            setStakeEndTime(currentTime);
          } else {
            setStakeEndTime(endTimeStamp);
          }
          // setLoarder1(false)
        }
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };
  const fetchStakingData1 = async (useV2 = false) => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
  subscribeds(where: {by: "${account}"}, orderBy: blockTimestamp, orderDirection: desc) {
      blockTimestamp
      blockNumber
      amountPurchased
      by
      endTime
      id
      tokenPrice
      transactionHash
    }
  }`,
      variables: {},
    });

    var config = {
      method: "post",
      url: useV2
        ? Environment.gemSubscriptionMultiple
        : Environment.gemsSubscribeGrap,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(config)
      .then(async function (response) {
        const resData = response?.data?.data?.subscribeds;
        // console.log("43353453454", resData);
        if ((!resData || resData.length === 0) && !useV2) {
          return fetchStakingData1(true);
        }
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          let bcc = a?.sort();
          // setStakeIndux(bcc);
          setStakingData1(resData[0]);

          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds

          if (!endTimeStamp.isValid() || currentTime.isAfter(endTimeStamp)) {
            if (!useV2) {
              // Try again with gemSubscriptionMultiple
              return fetchStakingData1(true);
            } else {
              setStakeEndTime1(currentTime);
            }
          } else {
            setStakeEndTime1(endTimeStamp);
          }
          // setLoarder1(false)
        }
        // setLoarder1(false);
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };

  //   const StakeIndec=async()=>{
  //     const bal = await getGemsStakedIndex(account);
  //     console.log(bal, 'bal');
  //     if (bal !== null || bal !== undefined) {
  //       if(bal==0){
  //         setStakeIndux([])
  //       }else{
  //         setStakeIndux([parseInt(bal)-1])
  //       }

  //     }
  //  }

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(account);

    if (staked) {
      setStakedAmount(staked);
    }
  };

  const inputField1Handler6 = (e) => {
    if (e.target.checked == true) {
      setCheked3(true);
    } else {
      setCheked3(false);
    }
  };

  const inputField1Handler7 = (e) => {
    if (e.target.checked == true) {
      setCheked4(true);
    } else {
      setCheked4(false);
    }
  };
  const tokenImages = {
    ETH: "/assets/eth-icon.svg",
    USDT: "/assets/usdt.svg",
    DOP: "/assets/dop.svg",
    GEMS: "/assets/newgemslogosvg.svg",
    TOMI: "/assets/tomi-icon-drop.svg",
    USDC: "/assets/usdc.svg",
    WBTC: "/assets/wbtc.svg",
    LINK: "/assets/link.svg", // ✅ added
    UNI: "/assets/uni.svg",
    PEPE: "/assets/pepe.svg", // ✅ added
  };

  console.log("maintagggg", chainId, parseInt(CHAIN), account, mainTag);

  return (
    <>
      {loaderr1 && <Loader />}
      {loaderr && (
        <Loader text={"Please wait, your transaction is in process"} />
      )}
      <Navbar setShow={setShow} />
      <section className="main-banner">
        <video
          className="main-banner-video"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="/loginvideo.mp4" type="video/mp4" />
        </video>
        {/* <img
          src="/assets/leftshade.png"
          alt="leftshade"
          className="leftshade"
        />
        <img
          src="/assets/rightshade.png"
          alt="rightshade"
          className="rightshade"
        /> */}
        {/* <img
          src="\assets\homepage-bg.png"
          alt="img"
          className="img-fluid banner-bg"
        />
        <img
          src="\assets\mblviewbg.png"
          alt="img"
          className="img-fluid mblviewbanner-bg d-none"
        /> */}
        <div className="container">
          <div className="banner-content">
            <div className="mainparent">
              <div className="timermain">
                <div className="timerleft">
                  <div className="mainiconimg">
                    <img
                      src={Presale?.image}
                      alt="iconimginner"
                      className="iconimginner"
                    />
                  </div>
                  <div className="mainicontexts">
                    <h6 className="timerhead">{Presale?.name}</h6>
                    {/* <p className="newpara">Sale Round 1 Ends in:</p> */}
                    {role !== "institution" ? (
                      <>
                        {currentTime <
                        new Date(parseInt(currentRount?.startTime)) ? (
                          <p className="newpara">Round {niceName} Starts in:</p>
                        ) : (
                          <>
                            {currentTime >
                              new Date(parseInt(currentRount?.startTime)) &&
                            currentTime <
                              new Date(parseInt(currentRount?.endTime)) ? (
                              <p className="newpara">
                                Round {niceName} Ends in:
                              </p>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {role !== "institution" ? (
                  <>
                    {timeshow ? (
                      <p className="timerended">Sale ended!</p>
                    ) : (
                      currentRount !== null &&
                      currentRount !== undefined && (
                        <>
                          <RoundTimer
                            currentRount={currentRount}
                            currentTime={currentTime}
                            setTimeshow={setTimeshow}
                            startTime11={startTime11}
                            history={history}
                            timeshow={timeshow}
                          />
                        </>
                      )
                    )}
                  </>
                ) : (
                  ""
                )}
                {/* {role !== "institution" ? (
                  <>
                    {timeshow ? (
                      <p className="timerended">Sale ended!</p>
                    ) : (
                      <span className="innertimertext">
                        {day ? day : 0}D : {hour ? hour : 0}H : {min ? min : 0}M
                        : {sec ? sec : 0}S
                      </span>
                    )}
                  </>
                ) : (
                  ""
                )} */}
              </div>
              <div className="brdr"></div>
              <h3 className="bottomtext">
                Want to learn more about the project?{" "}
                <span
                  onClick={() =>
                    window.open("https://www.xen.trade/xen", "_blank")
                  }
                >
                  {" "}
                  Project Details Page
                </span>
              </h3>
            </div>

            <div className="twice-content">
              <div className="upper-content">
                <div className="left">
                  <img
                    src={Presale?.image}
                    alt="img"
                    className="img-fluid tokennnimmgg"
                  />
                  <div className="text">
                    <h6>{Presale?.name}</h6>
                    <p>${Presale?.symbol}</p>
                  </div>
                </div>
                <div className="right">
                  {/* <h6>${tomi?.toFixed(2)}</h6>
                {change24hr1 > 0 ? (
                  <p>{change24hr1?.toFixed(2)}% (1d)</p>
                ) : (
                  <p className="red">{change24hr1?.toFixed(2)}% (1d)</p>
                )} */}
                  <>
                    {role === "institution" ? (
                      <h6>
                        ${price ? parseFloat(price)?.toFixed(8) : "0.000"} USD
                      </h6>
                    ) : (
                      <>
                        {priceCheck ||
                        (stakedAmount >= 5555 && stakingData?.length > 0) ||
                        moment().isBefore(stakeEndTime1) ? (
                          <>
                            {(stakedAmount >= 5555 &&
                              stakingData?.length > 0) ||
                            moment().isBefore(stakeEndTime1) ? (
                              <div className="right-text-content">
                                <div className="inner-left">
                                  <h5>Special offer</h5>
                                  <p className="special-para">
                                    You save {currentRoundd == 1 ? "20" : "7"}%
                                    {priceCheck
                                      ? `+ ${parseInt(percent)}%`
                                      : ""}
                                  </p>
                                </div>
                                <div className="inner-right">
                                  <h6>
                                    {" "}
                                    <h6>
                                      $
                                      {discountedPriceee
                                        ? parseFloat(
                                            discountedPriceee,
                                          )?.toFixed(8)
                                        : "0.000"}{" "}
                                      USD
                                    </h6>
                                  </h6>
                                  {/* <p>${parseFloat(price).toFixed(8)}</p> */}
                                </div>
                              </div>
                            ) : !(
                                stakedAmount >= 5555 && stakingData?.length > 0
                              ) || !moment().isBefore(stakeEndTime1) ? (
                              <h6>
                                $
                                {price
                                  ? parseFloat(price)?.toFixed(8)
                                  : "0.000"}{" "}
                                USD
                              </h6>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <h6>
                            ${price ? parseFloat(price)?.toFixed(8) : "0.000"}{" "}
                            USD
                          </h6>
                        )}
                      </>
                    )}
                  </>
                </div>
              </div>
              {role !== "institution" ? (
                <div className="discount-offer-removed">
                  {/* <img
                    src="/assets/discontbgnew.png"
                    alt="img"
                    className="img-fluid discont-bg"
                  />
                  <div className="left-sidee">
                    <div className="upper-text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <path
                          d="M20.5833 3.25H5.41666L2.16666 9.75L13 22.75L23.8333 9.75L20.5833 3.25ZM10.4217 8.66667L12.0467 5.41667H13.9533L15.5783 8.66667H10.4217ZM11.9167 10.8333V18.07L5.89332 10.8333H11.9167ZM14.0833 10.8333H20.1067L14.0833 18.07V10.8333ZM20.865 8.66667H17.9942L16.3692 5.41667H19.24L20.865 8.66667ZM6.75999 5.41667H9.63082L8.00582 8.66667H5.13499L6.75999 5.41667Z"
                          fill="#E89735"
                        />
                      </svg>
                      <h6>Gems Premium</h6>
                    </div>
                    {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                    moment().isBefore(stakeEndTime1) ? (
                      <p>
                        Subscribe to Gems Premium and receive upto{" "}
                        {currentRoundd == 1 ? "20" : "7"}% discount{" "}
                      </p>
                    ) : (
                      <p>
                        Subscribe to Gems Premium and receive upto{" "}
                        {currentRoundd == 1 ? "20" : "7"}% discount{" "}
                      </p>
                    )}
                  </div>
                  <div className="right-sidee">
                    {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                    moment().isBefore(stakeEndTime1) ? (
                      <div className="see-plan">
                        <a href="/discount" className="btn-seeplan">
                          see my plan
                        </a>
                        <p>
                          Plan expires on{" "}
                          {moment(stakeEndTime)?.format("DD/MM/YY")}
                        </p>
                      </div>
                    ) : (
                      <a href="/discount" className="btn-discount">
                        Get gems premium
                      </a>
                    )}
                  </div> */}
                </div>
              ) : (
                ""
              )}
              {/* <div className="availablemain">
                <h6 className="availablehead">Available Credit  <div className="tooltip-div">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip
                        id="smooth-tooltip"
                        onMouseEnter={handleTooltipMouseEnter}
                        onMouseLeave={handleTooltipMouseLeave}
                      >
                        <h5>Available Credit</h5>
                        <p>This indicates the available allocation for purchasing during the presale associated with this leader code.</p>
                      </Tooltip>
                    }
                    show={showTooltip}
                  >
                    <div
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: "pointer" }}
                    >
                      <svg style={{ marginTop: "-5px" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99967 1.33333C4.32634 1.33333 1.33301 4.32666 1.33301 7.99999C1.33301 11.6733 4.32634 14.6667 7.99967 14.6667C11.673 14.6667 14.6663 11.6733 14.6663 7.99999C14.6663 4.32666 11.673 1.33333 7.99967 1.33333ZM7.49967 5.33333C7.49967 5.05999 7.72634 4.83333 7.99967 4.83333C8.27301 4.83333 8.49967 5.05999 8.49967 5.33333V8.66666C8.49967 8.93999 8.27301 9.16666 7.99967 9.16666C7.72634 9.16666 7.49967 8.93999 7.49967 8.66666V5.33333ZM8.61301 10.92C8.57967 11.0067 8.53301 11.0733 8.47301 11.14C8.40634 11.2 8.33301 11.2467 8.25301 11.28C8.17301 11.3133 8.08634 11.3333 7.99967 11.3333C7.91301 11.3333 7.82634 11.3133 7.74634 11.28C7.66634 11.2467 7.59301 11.2 7.52634 11.14C7.46634 11.0733 7.41967 11.0067 7.38634 10.92C7.35301 10.84 7.33301 10.7533 7.33301 10.6667C7.33301 10.58 7.35301 10.4933 7.38634 10.4133C7.41967 10.3333 7.46634 10.26 7.52634 10.1933C7.59301 10.1333 7.66634 10.0867 7.74634 10.0533C7.90634 9.98666 8.09301 9.98666 8.25301 10.0533C8.33301 10.0867 8.40634 10.1333 8.47301 10.1933C8.53301 10.26 8.57967 10.3333 8.61301 10.4133C8.64634 10.4933 8.66634 10.58 8.66634 10.6667C8.66634 10.7533 8.64634 10.84 8.61301 10.92Z" fill="black" />
                      </svg>
                    </div>
                  </OverlayTrigger>
                </div></h6>
                <p className="availablepara"><span className="greynumber">${parseInt(limitObj?.saleCount)}</span>/${limitObj?.buyingLimit}</p>
                <ProgressBar now={limitObjperc} />
                <div className="Apppppppp">
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={limitObjperc}
                    className="d-none"
                  />
                  <div className="gauge-container">
                    <div className="gauge">
                      <div className="gauge-indicator" style={{ left: gaugePosition }}></div>
                    </div>
                    <div className="gauge-labels">
                      <span>Low</span>
                      <span>Medium</span>
                      <span>High</span>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            {role === "institution" ? (
              <div className="bottom-content">
                <h6 className="main-head">Buy</h6>
                <div className="parent-box">
                  <img
                    src="\assets\swap-arrow.svg"
                    alt="img"
                    className="img-fluid swap-arrow"
                  />
                  <div className="inner-box">
                    {" "}
                    <div className="left">
                      <div class="dropdown">
                        <button
                          class="dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="flexset">
                            <img
                              src={tagImge}
                              alt="img"
                              className="img-fluid suxvsvsyucsusc"
                            />
                            <div className="text">
                              <h6>{mainTag}</h6>
                            </div>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="5"
                            viewBox="0 0 8 5"
                            fill="none"
                          >
                            <path
                              d="M7.81779 1.29713L5.9829 3.24602L4.86253 4.44207C4.38809 4.94599 3.61641 4.94599 3.14197 4.44207L0.181004 1.29713C-0.207694 0.88428 0.0723969 0.180007 0.615431 0.180007H3.82219H7.38336C7.93211 0.180007 8.20648 0.88428 7.81779 1.29713Z"
                              fill="#02171D"
                            />
                          </svg>
                        </button>
                        {/* <ul className="dropdown-menu">
                          {allowedTokens.map((token) => (
                            <li key={token.symbol}>
                              <a
                                className="dropdown-item gscrxcsx"
                                onClick={() => changeTag1(token.symbol)}
                              >
                                <img
                                  src={
                                    tokenImages[token.symbol] ||
                                    "/assets/default.svg"
                                  } // fallback if not found
                                  alt={token.symbol}
                                  className="img-fluid"
                                />{" "}
                                {token.symbol}
                              </a>
                            </li>
                          ))}
                        </ul> */}
                      </div>
                    </div>
                    <div className="right">
                      <h6>
                        Balance:{" "}
                        <span>
                          {
                            mainTag === "ETH"
                              ? blanceOfEth > 0
                                ? blanceOfEth?.toFixed(4)
                                : "0.000"
                              : mainTag === "USDT"
                                ? balanceeUsdt > 0
                                  ? balanceeUsdt?.toFixed(4)
                                  : "0.000"
                                : mainTag === "USDC"
                                  ? balaceOfUsdc > 0
                                    ? balaceOfUsdc?.toFixed(4)
                                    : "0.000"
                                  : mainTag === "WBTC"
                                    ? balaceOfWbtc > 0
                                      ? balaceOfWbtc?.toFixed(6)
                                      : "0.000"
                                    : mainTag === "TOMI"
                                      ? balaceOfTmi > 0
                                        ? balaceOfTmi?.toFixed(6)
                                        : "0.000"
                                      : mainTag === "DOP"
                                        ? balaceOfDoppp > 0
                                          ? balaceOfDoppp?.toFixed(6)
                                          : "0.000"
                                        : gemsBalance > 0
                                          ? gemsBalance?.toFixed(6)
                                          : "0.000"

                            // balaceOfTmi > 0
                            //   ? balaceOfTmi
                            //     ?.toFixed(4)
                            //   : "0.000"
                          }{" "}
                          {mainTag === "ETH"
                            ? " ETH "
                            : mainTag === "USDT"
                              ? " USDT "
                              : mainTag === "USDC"
                                ? "USDC"
                                : mainTag === "WBTC"
                                  ? "WBTC"
                                  : mainTag === "TOMI"
                                    ? "TOMI"
                                    : mainTag === "DOP"
                                      ? "DOP"
                                      : "GEMS"}
                        </span>{" "}
                      </h6>
                      {/* balanceeUsdt?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") */}
                      <input
                        onChange={inputField1Handler}
                        value={inputFeild}
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        placeholder="0.00"
                      />
                      {/* <p>0.00</p> */}
                    </div>
                  </div>
                  <div className="inner-box">
                    <div className="leftiii">
                      <img
                        src={Presale?.image}
                        alt="img"
                        className="img-fluid"
                        style={{
                          width: "35px",
                          height: "35px",
                          borderRadius: "120px",
                        }}
                      />
                      <div className="text">
                        <h6>{Presale?.name}</h6>
                        <p className="textpara">${Presale?.symbol}</p>
                      </div>
                    </div>
                    <div className="right">
                      <h6>
                        {/* Balance:{" "} */}
                        {/* <span style={{ color: "#fff" }}>
          {balacefAccountTomii > 0
            ? balacefAccountTomii
              ?.toFixed(4)
            : "0.000"}
        </span> */}
                      </h6>
                      <input
                        onChange={inputField1Handler1}
                        value={inputFeild1}
                        disabled
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        placeholder="0.00"
                      />
                      {/* <p>0.00</p> */}
                    </div>
                  </div>
                </div>
                {role === "institution" && (
                  <div
                    className="material-textfield"
                    style={{ marginTop: "20px", marginBottom: "25px" }}
                  >
                    <input
                      onChange={inputField1Handler5}
                      value={inputFeild5}
                      onWheel={(e) => e.target.blur()}
                      type="text"
                      placeholder="Enter only ERC20 wallet address"
                    />
                    <label>
                      Enter ${Presale?.symbol} recipient wallet address
                    </label>
                  </div>
                )}
                <div className="bottom-text">
                  {/* <div className="inner-text">
<p>Receive:</p>
<h6>
{inputFeild1
  ? inputFeild1
    ?.toFixed(3)
  : "0.00"}{" "}
TOMI
</h6>
</div>
<div className="inner-text">
<p>+{aaa / 10}% Bonus:</p>
<h6>
{inputFeild1
  ? ((inputFeild1 * (aaa / 10)) / 100)
    ?.toFixed(3)
  : "0.00"}{" "}
TOMI
</h6>
</div> */}
                  <div className="inner-text-bold">
                    <h6>Total:</h6>
                    <h6>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {checkBoxx
                            ? parseFloat(
                                inputFeild1 + inputFeild1 * insurancePer,
                              )?.toFixed(4)
                            : parseFloat(inputFeild1)?.toFixed(4)}
                        </>
                      ) : (
                        "0.00"
                      )}{" "}
                      ${Presale?.symbol}
                    </h6>
                  </div>
                  {/* <div className="inner-text">
                    <p>Unlock Date:</p>
                    <h6>{date}</h6>
                    <h6>Q1,2024</h6>
                  </div> */}
                </div>
                {account ? (
                  <>
                    {
                      role !== "institution" ? (
                        <>
                          {mainTag === "ETH" ? (
                            <>
                              {inputFeild == "" ||
                              inputFeild == null ||
                              inputFeild <= 0 ||
                              blanceOfEth <
                                (checkBoxx
                                  ? parseFloat(inputFeild) +
                                    parseFloat(inputFeild) * insurancePer
                                  : inputFeild) ? (
                                <>
                                  <button className=" btn-buy">
                                    Buy ${Presale?.symbol}{" "}
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="newClasss"
                                  onClick={handlerPop}
                                >
                                  Buy ${Presale?.symbol}{" "}
                                </button>
                              )}
                            </>
                          ) : (
                            <>
                              {mainTag === "USDT" ? (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ||
                                  balanceeUsdt <
                                    (checkBoxx
                                      ? parseFloat(inputFeild) +
                                        parseFloat(inputFeild) * insurancePer
                                      : inputFeild) ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy ${Presale?.symbol}{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy ${Presale?.symbol}{" "}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy ${Presale?.symbol}{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy ${Presale?.symbol}{" "}
                                    </button>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {check ? (
                            <>
                              {mainTag === "ETH" ? (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ||
                                  blanceOfEth <
                                    (checkBoxx
                                      ? parseFloat(inputFeild) +
                                        parseFloat(inputFeild) * insurancePer
                                      : inputFeild) ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy ${Presale?.symbol}{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy ${Presale?.symbol}{" "}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {mainTag == "USDT" ? (
                                    // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                    <>
                                      {inputFeild == "" ||
                                      inputFeild == null ||
                                      inputFeild <= 0 ||
                                      balanceeUsdt <
                                        (checkBoxx
                                          ? parseFloat(inputFeild) +
                                            parseFloat(inputFeild) *
                                              insurancePer
                                          : inputFeild) ? (
                                        <button className=" btn-buy">
                                          Buy ${Presale?.symbol}
                                        </button>
                                      ) : (
                                        <button
                                          className="newClasss"
                                          onClick={handlerPop}
                                        >
                                          Buy ${Presale?.symbol}{" "}
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {mainTag == "USDC" ? (
                                        // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                        <>
                                          {inputFeild == "" ||
                                          inputFeild == null ||
                                          inputFeild <= 0 ||
                                          balaceOfUsdc <
                                            (checkBoxx
                                              ? parseFloat(inputFeild) +
                                                parseFloat(inputFeild) *
                                                  insurancePer
                                              : inputFeild) ? (
                                            <button className=" btn-buy">
                                              Buy ${Presale?.symbol}
                                            </button>
                                          ) : (
                                            <button
                                              className="newClasss"
                                              onClick={handlerPop}
                                            >
                                              Buy ${Presale?.symbol}{" "}
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {mainTag == "WBTC" ? (
                                            // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                            <>
                                              {inputFeild == "" ||
                                              inputFeild == null ||
                                              inputFeild <= 0 ||
                                              balaceOfWbtc <
                                                (checkBoxx
                                                  ? parseFloat(inputFeild) +
                                                    parseFloat(inputFeild) *
                                                      insurancePer
                                                  : inputFeild) ? (
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}
                                                </button>
                                              ) : (
                                                <button
                                                  className="newClasss"
                                                  onClick={handlerPop}
                                                >
                                                  Buy ${Presale?.symbol}{" "}
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                            <>
                                              {mainTag === "TOMI" ? (
                                                <>
                                                  {inputFeild == "" ||
                                                  inputFeild == null ||
                                                  inputFeild <= 0 ||
                                                  balaceOfTmi <
                                                    (checkBoxx
                                                      ? parseFloat(inputFeild) +
                                                        parseFloat(inputFeild) *
                                                          insurancePer
                                                      : inputFeild) ? (
                                                    <button className=" btn-buy">
                                                      Buy ${Presale?.symbol}
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="newClasss"
                                                      onClick={handlerPop}
                                                    >
                                                      Buy $
                                                      {Presale?.symbol}{" "}
                                                    </button>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {mainTag === "DOP" ? (
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      inputFeild <= 0 ||
                                                      balaceOfDoppp <
                                                        (checkBoxx
                                                          ? parseFloat(
                                                              inputFeild,
                                                            ) +
                                                            parseFloat(
                                                              inputFeild,
                                                            ) *
                                                              insurancePer
                                                          : inputFeild) ? (
                                                        <button className=" btn-buy">
                                                          Buy ${Presale?.symbol}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $
                                                          {Presale?.symbol}{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      inputFeild <= 0 ||
                                                      gemsBalance <
                                                        (checkBoxx
                                                          ? parseFloat(
                                                              inputFeild,
                                                            ) +
                                                            parseFloat(
                                                              inputFeild,
                                                            ) *
                                                              insurancePer
                                                          : inputFeild) ? (
                                                        <button className=" btn-buy">
                                                          Buy ${Presale?.symbol}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $
                                                          {Presale?.symbol}{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <button className=" btn-buy">
                              Buy ${Presale?.symbol}
                            </button>
                          )}
                        </>
                      )
                      // <button className=" newClasss" onClick={handlerPop}>Buy Do </button>
                    }
                  </>
                ) : (
                  <button className="btn-buy" onClick={() => setShow(true)}>
                    Buy ${Presale?.symbol}
                  </button>
                )}
              </div>
            ) : (
              <div className="custom-tabs">
                <Tabs
                  defaultActiveKey={tab}
                  id="uncontrolled-tab-example"
                  onSelect={tabHandler}
                >
                  <Tab eventKey="home" title="Buy Token">
                    <div className="bottom-content">
                      <div className="twice-contentt">
                        <h6 className="main-head m-0">
                          Buy ${Presale?.symbol}
                        </h6>
                        <h6 style={{ fontFamily: "hsemibold" }}>
                          Balance:{" "}
                          {mainTag === "ETH"
                            ? blanceOfEth > 0
                              ? blanceOfEth?.toFixed(4)
                              : "0.000"
                            : mainTag === "USDT"
                              ? balanceeUsdt > 0
                                ? balanceeUsdt?.toFixed(4)
                                : "0.000"
                              : mainTag === "USDC"
                                ? balaceOfUsdc > 0
                                  ? balaceOfUsdc?.toFixed(4)
                                  : "0.000"
                                : mainTag === "WBTC"
                                  ? balaceOfWbtc > 0
                                    ? balaceOfWbtc?.toFixed(6)
                                    : "0.000"
                                  : mainTag === "UNI"
                                    ? balaceOfUnii > 0
                                      ? balaceOfUnii?.toFixed(6)
                                      : "0.000"
                                    : mainTag === "LINK"
                                      ? balaceOfLinkk > 0
                                        ? balaceOfLinkk?.toFixed(6)
                                        : "0.000"
                                      : mainTag === "PEPE"
                                        ? balaceOfPepee > 0
                                          ? balaceOfPepee?.toFixed(6)
                                          : "0.000"
                                        : mainTag === "DOP"
                                          ? balaceOfDoppp > 0
                                            ? balaceOfDoppp?.toFixed(6)
                                            : "0.000"
                                          : mainTag === "TOMI"
                                            ? balaceOfTmi > 0
                                              ? balaceOfTmi?.toFixed(4)
                                              : "0.000"
                                            : gemsBalance > 0
                                              ? gemsBalance?.toFixed(4)
                                              : "0.000"}{" "}
                          {mainTag === "ETH"
                            ? " ETH "
                            : mainTag === "USDT"
                              ? " USDT "
                              : mainTag === "USDC"
                                ? "USDC"
                                : mainTag === "WBTC"
                                  ? "WBTC"
                                  : mainTag === "UNI"
                                    ? "UNI"
                                    : mainTag === "LINK"
                                      ? "LINK"
                                      : mainTag === "PEPE"
                                        ? "PEPE"
                                        : mainTag === "DOP"
                                          ? "DOP"
                                          : mainTag === "TOMI"
                                            ? "TOMI"
                                            : "GEMS"}
                        </h6>
                      </div>

                      <div className="parent-box">
                        <img
                          src="\assets\swap-arrow.svg"
                          alt="img"
                          className="img-fluid swap-arrow"
                        />
                        <div className="inner-box">
                          {" "}
                          <div className="left">
                            <div class="dropdown">
                              <button
                                class="dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <div className="flexset">
                                  <img
                                    src={tagImge}
                                    alt="img"
                                    className="img-fluid suxvsvsyucsusc"
                                  />
                                  <div className="text">
                                    <h6>{mainTag}</h6>
                                  </div>
                                </div>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="8"
                                  height="5"
                                  viewBox="0 0 8 5"
                                  fill="none"
                                >
                                  <path
                                    d="M7.81779 1.11677L5.9829 3.06566L4.86253 4.26171C4.38809 4.76563 3.61641 4.76563 3.14197 4.26171L0.181004 1.11677C-0.207694 0.703921 0.0723969 -0.000351429 0.615431 -0.000351429H3.82219H7.38336C7.93211 -0.000351429 8.20648 0.703921 7.81779 1.11677Z"
                                    fill="white"
                                  />
                                </svg>
                              </button>
                              <ul class="dropdown-menu">
                                {allowedTokens.map((token) => (
                                  <li key={token.symbol}>
                                    <a
                                      className="dropdown-item gscrxcsx"
                                      onClick={() => changeTag1(token.symbol)}
                                    >
                                      <img
                                        src={
                                          tokenImages[token.symbol] ||
                                          "/assets/default.svg"
                                        } // fallback if not found
                                        alt={token.symbol}
                                        className="img-fluid"
                                      />{" "}
                                      {token.symbol}
                                    </a>
                                  </li>
                                ))}
                                {/* <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("ETH")}
                                  >
                                    <img
                                      src="/assets/eth-icon.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    ETH
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("USDT")}
                                  >
                                    <img
                                      src="/assets/usdt.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    USDT
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("USDC")}
                                  >
                                    <img
                                      src="\assets\usdc.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    USDC
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("GEMS")}
                                  >
                                    <img
                                      src="\assets\newgemslogosvg.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    GEMS
                                  </a>
                                </li> */}
                                {/* <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("WBTC")}
                                  >
                                    <img
                                      src="\assets\wbtc.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    WBTC
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("LINK")}
                                  >
                                    <img
                                      src="\assets\link.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    LINK
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("TOMI")}
                                  >
                                    <img
                                      src="\assets\tomi-icon-drop.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    TOMI
                                  </a>
                                </li>

                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("PEPE")}
                                  >
                                    <img
                                      src="\assets\pepe.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    PEPE
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("UNI")}
                                  >
                                    <img
                                      src="\assets\uniswap.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    UNI
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("DOP")}
                                  >
                                    <img
                                      src="\assets\dop.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    DOP
                                  </a>
                                </li> */}
                              </ul>
                            </div>
                          </div>
                          <div className="right">
                            <h6>
                              $
                              {inputFeild1 && inputFeild
                                ? amountInUsdt?.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2,
                                  })
                                : "0.00"}
                            </h6>
                            {/* balanceeUsdt?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") */}
                            <input
                              onChange={inputField1Handler}
                              value={inputFeild}
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              placeholder="0.00"
                            />
                            {/* <p>0.00</p> */}
                          </div>
                        </div>
                        <div className="inner-box">
                          <div className="leftiii">
                            <img
                              src={Presale?.image}
                              alt="img"
                              className="img-fluid"
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "120px",
                              }}
                            />
                            <div className="text">
                              <h6>{Presale?.name}</h6>
                              <p className="textpara">${Presale?.symbol}</p>
                            </div>
                          </div>
                          <div className="right">
                            <h6>
                              {/* Balance:{" "} */}
                              {/* <span style={{ color: "#fff" }}>
{balacefAccountTomii > 0
? balacefAccountTomii
?.toFixed(4)
: "0.000"}
</span> */}
                            </h6>
                            <input
                              onChange={inputField1Handler1}
                              value={inputFeild1}
                              disabled
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              placeholder="0.00"
                            />
                            {/* <p>0.00</p> */}
                          </div>
                        </div>
                      </div>

                      {/* <div className="getinsurance-flow">
                        <img
                          src="\assets\insurance-bg.png"
                          alt="img"
                          className="img-fluid insurance-shadow"
                        />
                        <div className="left-side">
                          <div className="lefthead">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M13.5007 9.49826L13.5007 6.79987L9.38942 10.9008L6.93848 9.17174L6.93848 11.6734L9.38941 13.5202L13.5007 9.49826Z"
                                fill="#329879"
                              />
                              <path
                                d="M15.4004 5.93396L15.4004 3.68436L9.94927 0.63287L9.94927 2.88247L15.4004 5.93396Z"
                                fill="#329879"
                              />
                              <path
                                d="M4.48633 5.93396L4.48633 3.68436L9.93745 0.632871L10.8798 2.05067L9.93745 2.88248L4.48633 5.93396Z"
                                fill="#329879"
                              />
                              <path
                                d="M17.1221 10.7532L17.1221 5.93036L15.0664 5.93036L15.0664 10.7532L17.1221 10.7532Z"
                                fill="#329879"
                              />
                              <path
                                d="M2.7334 10.7532L2.7334 5.93036L4.78902 5.93036L4.78902 10.7532L2.7334 10.7532Z"
                                fill="#329879"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.26893 17.126C12.9144 15.8369 15.176 13.4242 15.0669 10.3578L17.1225 10.4369C17.2772 14.7847 14.0172 17.6273 9.95425 19.064L9.26893 17.126Z"
                                fill="#329879"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.6333 17.126C6.98789 15.8369 4.67972 13.4241 4.7888 10.3578L2.69363 10.4369C2.53896 14.7847 5.88506 17.6273 9.948 19.064L10.6333 17.126Z"
                                fill="#329879"
                              />
                            </svg>
                            <h6 className="protecthead">Gems Protect</h6>
                          </div>
                          <p>
                            Get 75% of your purchase covered by paying just 5%
                            of the total cost.{" "}
                          </p>
                        </div>
                        <div className="right-side">
                          {!checkBoxx ? (
                            <>
                              <button
                                onClick={handleShow2Insurance1}
                                className={
                                  inputFeild
                                    ? "addinsurance-btn"
                                    : "addinsurance-btn disabled"
                                }
                                // className="addinsurance-btn"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="25"
                                  viewBox="0 0 24 25"
                                  fill="none"
                                >
                                  <path
                                    d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.5L19.4 4.5L15.5 11.5H8.5L4.3 2.5H1V4.5H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3Z"
                                    fill="#329879"
                                  />
                                </svg>{" "}
                                <>
                                  {inputFeild1 > 0 ? (
                                    <>
                                      Add for{" "}
                                      {(
                                        inputFeild * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })}{" "}
                                      {mainTag}
                                    </>
                                  ) : (
                                    <>Add Gems Protect</>
                                  )}
                                </>
                              </button>
                            </>
                          ) : (
                            <>
                              <div className="insurance-added">
                                <div className="btn-added">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <path
                                      d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.50002L19.4 4.50002L15.5 11.5H8.5L4.3 2.50002H1V4.50002H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3ZM18 3.30002L16.6 1.90002L11.8 6.70002L9.2 4.10002L7.8 5.50002L11.8 9.50002L18 3.30002Z"
                                      fill="#E2E9EC"
                                    />
                                  </svg>
                                  <h6>Gems Protect Added</h6>
                                </div>
                                <div
                                  className="btnnotadded"
                                  onClick={() => {
                                    setCheckBoxx(false);
                                    setCheked3(false);
                                    setCheked4(false);
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <path
                                      d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.50002L19.4 4.50002L15.5 11.5H8.5L4.3 2.50002H1V4.50002H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3ZM18 3.30002L16.6 1.90002L11.8 6.70002L9.2 4.10002L7.8 5.50002L11.8 9.50002L18 3.30002Z"
                                      fill="#FC4F52"
                                    />
                                  </svg>
                                  <h6>Remove Gems Protect</h6>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div> */}
                      {role === "institution" && (
                        <div
                          className="material-textfield"
                          style={{ marginTop: "5px", marginBottom: "25px" }}
                        >
                          <input
                            onChange={inputField1Handler5}
                            value={inputFeild5}
                            onWheel={(e) => e.target.blur()}
                            type="text"
                            placeholder="Enter only ERC20 wallet address"
                          />
                          <label>
                            Enter ${Presale?.symbol} recipient wallet address
                          </label>
                        </div>
                      )}
                      <div className="bottom-text">
                        {/* <div className="inner-text">
<p>Receive:</p>
<h6>
{inputFeild1
? inputFeild1
?.toFixed(3)
: "0.00"}{" "}
TOMI
</h6>
</div>
<div className="inner-text">
<p>+{aaa / 10}% Bonus:</p>
<h6>
{inputFeild1
? ((inputFeild1 * (aaa / 10)) / 100)
?.toFixed(3)
: "0.00"}{" "}
TOMI
</h6>
</div> */}
                        {/* <div className="inner-text-bold">
                          <h6>sub Total</h6>
                          <h6>
                            {inputFeild1 && inputFeild
                              ? parseFloat((inputFeild1))
                                ?.toFixed(3)
                              : "0.00"}{" "}
                            ${Presale?.symbol}
                          </h6>
                        </div> */}
                        {/* <div className="inner-text-bold inner-text-bolddddd">
                          <div className="twice-text">
                            <h6>{round == 1 ? '20' : "7"}% Additional Tokens:</h6>
                            <p>For Golden Users </p>
                          </div>
                          <h6>
                            {stakedAmount >=  5555 ?
                              <>
                                {inputFeild1 && inputFeild
                                  ?
                                  ethValueCalcualte.toFixed(2)
                                  :
                                  "0.00"}
                              </>
                              :
                              0.00
                              // (parseFloat(inputFeild) / discountedPriceee) - parseFloat((inputFeild1))
                            }
                            {" "}${Presale?.symbol}
                          </h6>
                        </div> */}

                        <div className="inner-text-bold">
                          <h6 style={{ textAlign: "start" }}>You Receive:</h6>
                          <h6 className="newwwwww">
                            {(stakedAmount >= 5555 &&
                              stakingData?.length > 0) ||
                            moment().isBefore(stakeEndTime1) ? (
                              <>
                                {inputFeild1 && inputFeild
                                  ? parseFloat(inputFeild1) +
                                    parseInt(ethValueCalcualte?.toFixed(2))
                                  : "0.00"}
                              </>
                            ) : (
                              <>
                                {inputFeild1 && inputFeild
                                  ? parseFloat(inputFeild1)?.toFixed(3)
                                  : "0.00"}
                              </>
                            )}{" "}
                            ${Presale?.symbol}
                          </h6>
                        </div>
                        <div
                          className="inner-text-bold mt-3 w-100"
                          style={{
                            flexDirection: "column",
                            background: "#0A2228",
                          }}
                        >
                          {checkBoxx && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              className="w-100 mb-3"
                            >
                              <h6
                                style={{ color: "#05BADA", textAlign: "start" }}
                              >
                                Gems Protect
                              </h6>
                              <h6>
                                <>
                                  {inputFeild1 && inputFeild ? (
                                    <>
                                      {(
                                        inputFeild * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })}
                                    </>
                                  ) : (
                                    "0.00"
                                  )}
                                </>{" "}
                                {mainTag}
                                <span
                                  style={{
                                    fontSize: "18px",
                                    color: "#77868B",
                                    marginLeft: "5px",
                                  }}
                                >
                                  ($
                                  {inputFeild1 && inputFeild
                                    ? (
                                        amountInUsdt * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })
                                    : 0.0}
                                  )
                                </span>
                              </h6>
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="w-100"
                          >
                            <h6
                              style={{
                                color: "#05BADA",
                                fontFamily: "f37",
                                fontSize: "18px",
                              }}
                            >
                              You Pay:
                            </h6>
                            <div className="mainnettext">
                              <h6 style={{ marginBottom: "10px" }}>
                                <span
                                  style={{
                                    color: "#fff",
                                    fontSize: "18px",
                                    fontFamily: "f37",
                                  }}
                                >
                                  {inputFeild1 && inputFeild ? (
                                    <>
                                      {checkBoxx
                                        ? parseFloat(
                                            parseFloat(inputFeild) +
                                              inputFeild * insurancePer,
                                          )?.toFixed(4)
                                        : parseFloat(inputFeild)?.toFixed(4)}
                                    </>
                                  ) : (
                                    "0.00"
                                  )}
                                </span>{" "}
                                <span style={{ color: "#fff" }}>
                                  {" "}
                                  {mainTag}
                                </span>{" "}
                                <span
                                  style={{
                                    fontSize: "16px",
                                    color: "#85A8AE",
                                    fontFamily: "hregular",
                                  }}
                                >
                                  ($
                                  {inputFeild1 && inputFeild ? (
                                    <>
                                      {checkBoxx
                                        ? (
                                            amountInUsdt +
                                            amountInUsdt * insurancePer
                                          )?.toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 5,
                                          })
                                        : amountInUsdt?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 5,
                                            },
                                          )}
                                    </>
                                  ) : (
                                    0.0
                                  )}
                                  )
                                </span>
                              </h6>
                              <p className="mainnettext mb-0">
                                Network: <span>Arbitrum Mainnet</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <p className="willpay">
                          You will need to approve the transaction in your
                          wallet.
                        </p>
                        {/* <div className="inner-text-bold">
                          <h6>Unlocks On:</h6>
                          <h6>
                            Q1,2024
                          </h6>
                        </div> */}

                        {/* <div className="inner-text">
                          <p>Unlock Date:</p>
                          <h6>{date}</h6>
                          <h6>Q1,2024</h6>
                        </div> */}
                      </div>
                      {account ? (
                        <>
                          {!timeshow &&
                          currentTime >
                            new Date(parseInt(currentRount?.startTime)) &&
                          currentTime <
                            new Date(parseInt(currentRount?.endTime)) ? (
                            <>
                              {
                                role !== "institution" ? (
                                  <>
                                    {/* {psMaxxCap>=psmyTotlaPurchasess? */}
                                    <>
                                      {mainTag === "ETH" ? (
                                        <>
                                          {inputFeild == "" ||
                                          inputFeild == null ||
                                          inputFeild <= 0 ||
                                          blanceOfEth <
                                            (checkBoxx
                                              ? parseFloat(inputFeild) +
                                                parseFloat(inputFeild) *
                                                  insurancePer
                                              : inputFeild) ? (
                                            <>
                                              <button className=" btn-buy">
                                                Buy ${Presale?.symbol}{" "}
                                              </button>
                                            </>
                                          ) : (
                                            <button
                                              className="newClasss"
                                              onClick={handlerPop}
                                            >
                                              Buy ${Presale?.symbol}{" "}
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {mainTag == "USDT" ? (
                                            // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                            <>
                                              {inputFeild == "" ||
                                              inputFeild == null ||
                                              inputFeild <= 0 ||
                                              balanceeUsdt <
                                                (checkBoxx
                                                  ? parseFloat(inputFeild) +
                                                    parseFloat(inputFeild) *
                                                      insurancePer
                                                  : inputFeild) ? (
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}
                                                </button>
                                              ) : (
                                                <button
                                                  className="newClasss"
                                                  onClick={handlerPop}
                                                >
                                                  Buy ${Presale?.symbol}{" "}
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {mainTag == "USDC" ? (
                                                // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                                <>
                                                  {inputFeild == "" ||
                                                  inputFeild == null ||
                                                  inputFeild <= 0 ||
                                                  balaceOfUsdc <
                                                    (checkBoxx
                                                      ? parseFloat(inputFeild) +
                                                        parseFloat(inputFeild) *
                                                          insurancePer
                                                      : inputFeild) ? (
                                                    <button className=" btn-buy">
                                                      Buy ${Presale?.symbol}
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="newClasss"
                                                      onClick={handlerPop}
                                                    >
                                                      Buy $
                                                      {Presale?.symbol}{" "}
                                                    </button>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {mainTag == "WBTC" ? (
                                                    // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      inputFeild <= 0 ||
                                                      balaceOfWbtc <
                                                        (checkBoxx
                                                          ? parseFloat(
                                                              inputFeild,
                                                            ) +
                                                            parseFloat(
                                                              inputFeild,
                                                            ) *
                                                              insurancePer
                                                          : inputFeild) ? (
                                                        <button className=" btn-buy">
                                                          Buy $
                                                          {Presale?.symbol}{" "}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $
                                                          {Presale?.symbol}{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {mainTag == "LINK" ? (
                                                        <>
                                                          {inputFeild == "" ||
                                                          inputFeild == null ||
                                                          inputFeild <= 0 ||
                                                          balaceOfLinkk <
                                                            (checkBoxx
                                                              ? parseFloat(
                                                                  inputFeild,
                                                                ) +
                                                                parseFloat(
                                                                  inputFeild,
                                                                ) *
                                                                  insurancePer
                                                              : inputFeild) ? (
                                                            <button className=" btn-buy">
                                                              Buy $
                                                              {
                                                                Presale?.symbol
                                                              }{" "}
                                                            </button>
                                                          ) : (
                                                            <button
                                                              className="newClasss"
                                                              onClick={
                                                                handlerPop
                                                              }
                                                            >
                                                              Buy $
                                                              {
                                                                Presale?.symbol
                                                              }{" "}
                                                            </button>
                                                          )}
                                                        </>
                                                      ) : (
                                                        <>
                                                          {mainTag == "PEPE" ? (
                                                            <>
                                                              {inputFeild ==
                                                                "" ||
                                                              inputFeild ==
                                                                null ||
                                                              inputFeild <= 0 ||
                                                              balaceOfPepee <
                                                                (checkBoxx
                                                                  ? parseFloat(
                                                                      inputFeild,
                                                                    ) +
                                                                    parseFloat(
                                                                      inputFeild,
                                                                    ) *
                                                                      insurancePer
                                                                  : inputFeild) ? (
                                                                <button className=" btn-buy">
                                                                  Buy $
                                                                  {
                                                                    Presale?.symbol
                                                                  }{" "}
                                                                </button>
                                                              ) : (
                                                                <button
                                                                  className="newClasss"
                                                                  onClick={
                                                                    handlerPop
                                                                  }
                                                                >
                                                                  Buy $
                                                                  {
                                                                    Presale?.symbol
                                                                  }{" "}
                                                                </button>
                                                              )}
                                                            </>
                                                          ) : (
                                                            <>
                                                              {mainTag ==
                                                              "UNI" ? (
                                                                <>
                                                                  {inputFeild ==
                                                                    "" ||
                                                                  inputFeild ==
                                                                    null ||
                                                                  inputFeild <=
                                                                    0 ||
                                                                  balaceOfUnii <
                                                                    (checkBoxx
                                                                      ? parseFloat(
                                                                          inputFeild,
                                                                        ) +
                                                                        parseFloat(
                                                                          inputFeild,
                                                                        ) *
                                                                          insurancePer
                                                                      : inputFeild) ? (
                                                                    <button className=" btn-buy">
                                                                      Buy $
                                                                      {
                                                                        Presale?.symbol
                                                                      }{" "}
                                                                    </button>
                                                                  ) : (
                                                                    <button
                                                                      className="newClasss"
                                                                      onClick={
                                                                        handlerPop
                                                                      }
                                                                    >
                                                                      Buy $
                                                                      {
                                                                        Presale?.symbol
                                                                      }{" "}
                                                                    </button>
                                                                  )}
                                                                </>
                                                              ) : (
                                                                <>
                                                                  {mainTag ==
                                                                  "DOP" ? (
                                                                    <>
                                                                      {inputFeild ==
                                                                        "" ||
                                                                      inputFeild ==
                                                                        null ||
                                                                      inputFeild <=
                                                                        0 ||
                                                                      balaceOfDoppp <
                                                                        (checkBoxx
                                                                          ? parseFloat(
                                                                              inputFeild,
                                                                            ) +
                                                                            parseFloat(
                                                                              inputFeild,
                                                                            ) *
                                                                              insurancePer
                                                                          : inputFeild) ? (
                                                                        <button className=" btn-buy">
                                                                          Buy $
                                                                          {
                                                                            Presale?.symbol
                                                                          }{" "}
                                                                        </button>
                                                                      ) : (
                                                                        <button
                                                                          className="newClasss"
                                                                          onClick={
                                                                            handlerPop
                                                                          }
                                                                        >
                                                                          Buy $
                                                                          {
                                                                            Presale?.symbol
                                                                          }{" "}
                                                                        </button>
                                                                      )}
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      {mainTag ==
                                                                      "TOMI" ? (
                                                                        <>
                                                                          {inputFeild ==
                                                                            "" ||
                                                                          inputFeild ==
                                                                            null ||
                                                                          inputFeild <=
                                                                            0 ||
                                                                          balaceOfTmi <
                                                                            (checkBoxx
                                                                              ? parseFloat(
                                                                                  inputFeild,
                                                                                ) +
                                                                                parseFloat(
                                                                                  inputFeild,
                                                                                ) *
                                                                                  insurancePer
                                                                              : inputFeild) ? (
                                                                            <button className=" btn-buy">
                                                                              Buy
                                                                              $
                                                                              {
                                                                                Presale?.symbol
                                                                              }
                                                                            </button>
                                                                          ) : (
                                                                            <button
                                                                              className="newClasss"
                                                                              onClick={
                                                                                handlerPop
                                                                              }
                                                                            >
                                                                              Buy
                                                                              $
                                                                              {
                                                                                Presale?.symbol
                                                                              }{" "}
                                                                            </button>
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        <>
                                                                          {inputFeild ==
                                                                            "" ||
                                                                          inputFeild ==
                                                                            null ||
                                                                          inputFeild <=
                                                                            0 ||
                                                                          gemsBalance <
                                                                            (checkBoxx
                                                                              ? parseFloat(
                                                                                  inputFeild,
                                                                                ) +
                                                                                parseFloat(
                                                                                  inputFeild,
                                                                                ) *
                                                                                  insurancePer
                                                                              : inputFeild) ? (
                                                                            <button className=" btn-buy">
                                                                              Buy
                                                                              $
                                                                              {
                                                                                Presale?.symbol
                                                                              }
                                                                            </button>
                                                                          ) : (
                                                                            <button
                                                                              className="newClasss"
                                                                              onClick={
                                                                                handlerPop
                                                                              }
                                                                            >
                                                                              Buy
                                                                              $
                                                                              {
                                                                                Presale?.symbol
                                                                              }{" "}
                                                                            </button>
                                                                          )}
                                                                        </>
                                                                      )}
                                                                    </>
                                                                  )}
                                                                </>
                                                              )}
                                                            </>
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  </>
                                ) : (
                                  <>
                                    {mainTag === "ETH" ? (
                                      <>
                                        {check ? (
                                          <>
                                            {inputFeild == "" ||
                                            inputFeild == null ||
                                            inputFeild <= 0 ||
                                            blanceOfEth <
                                              (checkBoxx
                                                ? parseFloat(inputFeild) +
                                                  parseFloat(inputFeild) *
                                                    insurancePer
                                                : inputFeild) ? (
                                              <>
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}
                                                  {check}
                                                </button>
                                              </>
                                            ) : (
                                              <button
                                                className="newClasss"
                                                onClick={handlerPop}
                                              >
                                                Buy ${Presale?.symbol}{" "}
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <button className=" btn-buy">
                                            Buy ${Presale?.symbol}
                                          </button>
                                        )}
                                      </>
                                    ) : (
                                      // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                      <>
                                        {check ? (
                                          <>
                                            {inputFeild == "" ||
                                            inputFeild == null ||
                                            inputFeild <= 0 ||
                                            balanceeUsdt <
                                              (checkBoxx
                                                ? parseFloat(inputFeild) +
                                                  parseFloat(inputFeild) *
                                                    insurancePer
                                                : inputFeild) ? (
                                              <>
                                                <button className=" btn-buy">
                                                  Buy ${Presale?.symbol}
                                                </button>
                                              </>
                                            ) : (
                                              <button
                                                className="newClasss"
                                                onClick={handlerPop}
                                              >
                                                Buy ${Presale?.symbol}{" "}
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <button className=" btn-buy">
                                            Buy ${Presale?.symbol}
                                          </button>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                                // <button className=" newClasss" onClick={handlerPop}>Buy GEMS </button>
                              }
                            </>
                          ) : (
                            <button className="btn-buy">
                              Buy ${Presale?.symbol}
                            </button>
                          )}
                        </>
                      ) : (
                        <button
                          className="btn-buy"
                          onClick={() => setShow(true)}
                        >
                          Buy ${Presale?.symbol}
                        </button>
                      )}
                    </div>
                  </Tab>

                  {/* <Tab eventKey="profile" title="Buy NFTs">
                    <DopNft
                      psMaxxCap={psMaxxCap}
                      psmyTotlaPurchasess={psmyTotlaPurchasess}
                      timeshow={timeshow}
                      balaceOfWbtc={balaceOfWbtc}
                      balaceOfUsdc={balaceOfUsdc}
                      getAllowanceWbtc={getAllowanceWbtc}
                      getAllowanceUsdc={getAllowanceUsdc}
                      setShow={setShow}
                      price={price}
                      wbtcCurrentPrice={wbtcCurrentPrice}
                      ethPricevalue={ethPricevalue}
                      code={code}
                      setLoarder={setLoarder}
                      saleCurrentStaus={saleCurrentStaus}
                      currentRoundd={currentRoundd}
                      blanceOfEth={blanceOfEth}
                      balanceeUsdt={balanceeUsdt}
                      pepePrice={pepePrice}
                      tomiAllowance={tomiAllowance}
                      allowanceTpl={allowanceTpl}
                      balaceOfTmi={balaceOfTmi}
                      alowence={alowence}
                      sallowance={sallowance}
                      discoundedPriceee={discoundedPriceee}
                      tab={tab}
                      setMyPsTotlaPurchasess={setMyPsTotlaPurchasess}
                      psTotlaPurchasess={psTotlaPurchasess}
                      stakeIndex={stakeIndex}
                      stakedAmount={stakedAmount}
                      discountedPriceee={discountedPriceee}
                      round={round}
                      linkPricevalue={linkPricevalue}
                      uniPricevalue={uniPricevalue}
                      pepeAllowance={pepeAllowance}
                      linkAllowance={linkAllowance}
                      uniAllowance={uniAllowance}
                      balaceOfLinkk={balaceOfLinkk}
                      balaceOfPepee={balaceOfPepee}
                      balaceOfUnii={balaceOfUnii}
                      dopAllowance={dopAllowance}
                      balaceOfDoppp={balaceOfDoppp}
                      dopPricevalue={dopPricevalue}
                      insurancePer={insurancePer}
                      checkBoxx={checkBoxx}
                      tomiPrice={tomiPrice}
                      gemsAllowance={gemsAllowance}
                      gemsBalance={gemsBalance}
                      gemsPrice={gemsPrice}
                      allowedTokens={allowedTokens}
                      stakingData={
                        (stakedAmount >= 5555 && stakingData?.length > 0) ||
                        moment().isBefore(stakeEndTime1)
                          ? true
                          : false
                      }
                    />
                  </Tab> */}
                </Tabs>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
      <Modal
        className="connectwallet-modal buy-modal trx-modal"
        show={show1}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>${Presale?.symbol} Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-modal">
            {/* <img src="\assets\purchased.svg" alt="img" className="img-fluid" /> */}
            <h4>${Presale?.symbol} Purchase Completed ! </h4>
            <p
              style={{
                fontSize: "14px",
                marginTop: "8px",
                fontFamily: "hregular",
                marginBottom: "32px",
              }}
            >
              Here’s a summary of your transaction
            </p>
            <div className="token-purchased-area">
              <div className="single-value">
                <h5>
                  Tokens Received{" "}
                  <div className="tooltipmain">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M6.99984 12.8332C10.2215 12.8332 12.8332 10.2215 12.8332 6.99984C12.8332 3.77818 10.2215 1.1665 6.99984 1.1665C3.77818 1.1665 1.1665 3.77818 1.1665 6.99984C1.1665 10.2215 3.77818 12.8332 6.99984 12.8332Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 4.6665V6.99984"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 9.3335H7.00583"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div className="innertooltip">
                      <svg
                        className="arrowsvg"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="6"
                        viewBox="0 0 16 6"
                        fill="none"
                      >
                        <path
                          d="M5.36598 0.989335C6.87409 -0.330256 9.12591 -0.330255 10.634 0.989336L16 5.68457H0L5.36598 0.989335Z"
                          fill="#152E33"
                        />
                      </svg>
                      Added to your wallet balance shortly after confirmation
                    </div>
                  </div>
                </h5>

                <h6>
                  {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                  moment().isBefore(stakeEndTime1) ? (
                    <>
                      {inputFeild1 && inputFeild
                        ? parseFloat(inputFeild1) +
                          parseInt(ethValueCalcualte?.toFixed(2))
                        : "0.00"}
                    </>
                  ) : (
                    <>
                      {inputFeild1 && inputFeild
                        ? parseFloat(inputFeild1)?.toFixed(3)
                        : "0.00"}
                    </>
                  )}{" "}
                  ${Presale?.symbol}
                </h6>
              </div>
            </div>
            <div className="token-purchased-area tokenpurchasedlast">
              {!checkBoxx && (
                <div className="single-value">
                  <h5 style={{ color: "#fff" }}>Token Purchase Amount</h5>
                  <h6>
                    {inputFeild1 && inputFeild
                      ? parseFloat(inputFeild)
                      : "0.00"}{" "}
                    {mainTag}{" "}
                    <span style={{ fontSize: "14px", color: "#85A8AE" }}>
                      ($
                      {inputFeild1 && inputFeild
                        ? amountInUsdt?.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 5,
                          })
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              {/* {checkBoxx && (
                <div className="single-value">
                  <h5 style={{ color: "#329879" }}>Gems Protect</h5>
                  <h6>
                    <>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {(inputFeild * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            }
                          )}
                        </>
                      ) : (
                        "0.00"
                      )}
                    </>{" "}
                    {mainTag}
                    <span
                      style={{
                        fontSize: "18px",
                        color: "#77868B",
                        marginLeft: "5px",
                      }}
                    >
                      ($
                      {inputFeild1 && inputFeild
                        ? (amountInUsdt * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            }
                          )
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )} */}
              <div className="mainbrdr"></div>
              <div
                className={
                  checkBoxx ? "single-value newborderr" : "single-value"
                }
              >
                <h5 style={{ color: "#05BADA" }}>
                  Total Spent (incl. network fees) 
                </h5>
                <h6 style={{ color: "#05BADA" }}>
                  {inputFeild1 && inputFeild ? (
                    <>
                      {checkBoxx
                        ? parseFloat(
                            parseFloat(inputFeild) + inputFeild * insurancePer,
                          )
                        : parseFloat(inputFeild)}
                    </>
                  ) : (
                    "0.00"
                  )}{" "}
                  {mainTag}{" "}
                  <span style={{ fontSize: "14px", color: "#85A8AE" }}>
                    ($
                    {inputFeild1 && inputFeild ? (
                      <>
                        {checkBoxx
                          ? (
                              amountInUsdt +
                              amountInUsdt * insurancePer
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            })
                          : amountInUsdt?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            })}
                      </>
                    ) : (
                      0.0
                    )}
                    )
                  </span>
                </h6>
              </div>
            </div>

            <button
              className="btn-common"
              onClick={() => {
                handleClose();
                handleShow5();
              }}
              style={{ marginTop: "20px" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal followusonx-modal"
        show={show5}
        onHide={handleClose5}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Follow Us</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buydopnft-modal buynft-modal2">
            <img src="\assets\followx.svg" alt="img" className="img-fluid" />
            <h4>Follow Xen on X</h4>
            <p className="newdeisgnpara">
              Follow Xen on X to stay updated with news and announcements{" "}
            </p>
          </div>
          <div className="twice-btnsss">
            <button
              onClick={witterHandler}
              className="btn-proceed sscscscscscsc"
            >
              Follow Xen on X
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal premiumstake-modal newmodalbackdrop"
        show={show0}
        onHide={handleClos0}
        centered
        backdrop={false}
        keyboard={false}
      >
        <Modal.Body>
          <div className="stakingmodal">
            <div className="inner-content">
              <img
                src="\assets\premium\modalbg.png"
                alt="img"
                className="img-fluid modalbg-stake"
              />
              <img
                src="\assets\premium\goldenuser.svg"
                alt="img"
                className="img-fluid"
              />
              <h5>
                Get Gems Premium and <br />
                Receive {round == 1 ? "20" : "7"}% Discount
              </h5>
            </div>
            <div className="d-flex justify-content-center mb-4">
              {/* <p className="text-danger ">{walletError}</p> */}
            </div>
            <div className="stakingbtns">
              <button
                onClick={() => {
                  handleClos0();
                }}
                className="cancelbtn"
              >
                Continue
              </button>
              <button
                onClick={() => {
                  history.push("/discount");
                }}
                className="confirmbtn"
              >
                Get Gems Premium
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal nooreee learnmore-modal"
        show={show2insurance1}
        onHide={handleClose2Insurance1}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="disclaimerdiv">
            <div className="darktext">
              <div className="scrolltext">
                <p className="darkparaupper text-center">
                  You may choose to sign up for Gems Protect, in order to be
                  eligible to take part in Gems Protect you must:
                </p>

                <p className="darkpara">
                  <ol>
                    <li>purchase one or more {Presale?.name};</li>
                    <li>
                      deposit, claim, and trade all mined Tokens exclusively via
                      GEMS' Exchange; and
                    </li>
                    <li>
                      maintain an active account on the Exchange in all times
                      until the expiration of the {Presale?.name} product (which
                      matures within 18 months from the TGE).
                    </li>
                  </ol>
                </p>
                <p className="darkpara">
                  For the removal of any doubt any withdrawal of the Tokens from
                  the Exchange will result in an immediate cancelation of your
                  participation in the Gems Protect program.
                </p>

                <p className="darkpara">
                  Gems Protect allows you to recover up to 75% of the initial
                  purchase value of the acquired Tokens via the {Presale?.name},
                  meaning, if the total value of the {Presale?.name} that you
                  originally purchased will drop on Effective Day, we will
                  reimburse you in such way that your {Presale?.name} value will
                  increase to 75% of the initial purchase value of the acquired
                  {Presale?.name}. When calculating your P&L on Effective Day we
                  will consider the value of Tokens held by you in your account
                  with the Exchange and the ones that were sold via the
                  Exchange. We will reimburse you in USTD (or in any other
                  cryptocurrency as we see fit). The fee for participating in
                  the Gems Protect program is 5% of the value of the{" "}
                  {Presale?.name}, in case a few
                  {Presale?.name} were purchased by you, you will need to pay 5%
                  of their value in total.
                </p>

                <p className="darkpara">
                  <span className="headingtext formarginleft">
                    Gems Protect Coverage and Evaluation:
                  </span>
                  Gems Protect protection will be evaluated every month based on
                  the user's Profit & Loss (P&L) calculation. The protection
                  will expire if any of the following conditions are met:
                  <ol>
                    <li>
                      18 months have passed since the TGE, after which Gems
                      Protect is no longer valid.
                    </li>
                    <li>
                      Total rewards received from the miner exceed 75% of the
                      initial miner purchase cost. If the total value of mined
                      tokens claimed by the user (whether sold or held) reaches
                      75% of the miner's initial purchase price, Gems Protect
                      coverage terminates.
                    </li>
                    <li>
                      The value of mined tokens is double the initial miner
                      cost. If the total mined tokens (including those not yet
                      sold) reach a value of 2x the initial purchase price, Gems
                      Protect coverage terminates, as the tokens are liquid and
                      can be sold at market price.
                    </li>
                  </ol>
                </p>

                <p className="darkpara">
                  <span className="headingtext formarginleft">
                    Monthly Valuation and Calculation:
                  </span>
                </p>
                <p className="darkpara">
                  A fixed valuation date will be announced.
                </p>
                <p className="darkpara">
                  Every month, a snapshot will be taken on this date to assess
                  the user's P&L.
                </p>
                <p className="darkpara">
                  The token price will be determined using the 7-day average
                  price prior to the snapshot date.
                </p>

                <p className="darkpara">
                  The P&L calculation for the user's miners will be based on:
                </p>
                <p className="darkpara">
                  Total USDT generated from token sales by the user.
                </p>
                <p className="darkpara">
                  The total value of tokens still held, using the price
                  calculation method above.
                </p>

                <p className="darkpara">
                  Insurance Fund Allocation and Withdrawal Conditions
                </p>

                <p className="darkpara">
                  If a user qualifies for Gems Protect support in any given
                  month (i.e., their miner's total value is below 75% of the
                  initial purchase price), the calculated compensation amount
                  will be allocated to a sub-account in GEMS Exchange.
                </p>

                <p className="darkpara">
                  Users cannot withdraw these funds immediately.
                </p>

                <p className="darkpara">
                  The final Gems Protect calculation will be made only after 18
                  months, once the miner has completed its full cycle and all
                  potential earnings have been realized.
                </p>
                <p className="darkpara">
                  If, by the end of 18 months, the user's total P&L remains
                  below 75% of the initial purchase price, the accumulated Gems
                  Protect funds in the sub-account will be released for
                  withdrawal. <br /> <br />
                  If the user's P&L recovers above 75% during the 18-month
                  period, no Gems Protect funds will be paid out, even if
                  allocations were made in previous months.
                </p>
                <p className="darkpara">Reimbursement Mechanism</p>
                <p className="darkpara">
                  The preferred form of Gems Protect reimbursement is USDT.
                </p>
                <p className="darkpara">
                  In extreme cases, Gems Protect payments may be made in other
                  cryptocurrencies at our discretion.
                </p>

                <p className="darkpara">Gems Protect Participation Fee</p>
                <p className="darkpara">
                  A 5% fee of the total value of the purchased {Presale?.name}{" "}
                  will be required to enroll in Gems Protect. If multiple{" "}
                  {Presale?.name} are purchased, the fee applies to the total
                  value.
                </p>
              </div>
            </div>
            <div className="checkboxmainnnnnn">
              <label class="checkbox m-0" for="ch1">
                <input
                  type="checkbox"
                  onChange={inputField1Handler6}
                  id="ch1"
                  value={cheked3}
                  checked={cheked3}
                ></input>
                <span class="checkmark"></span>
              </label>
              <p className="checkboxpara">
                I confirm that I have read and understand the Terms & Conditions
              </p>
            </div>

            <div className="checkboxmainnnnnn">
              <label class="checkbox m-0" for="ch2">
                <input
                  type="checkbox"
                  id="ch2"
                  value={cheked4}
                  checked={cheked4}
                  onChange={inputField1Handler7}
                />
                <span class="checkmark"></span>
              </label>
              <p className="checkboxpara">I agree to the Terms & Conditions</p>
            </div>
            {/* disablebutton */}
            {cheked3 && cheked4 ? (
              <button
                className="continuebutton"
                onClick={handleClose2Insurance12}
              >
                Add Gems Protect
              </button>
            ) : (
              <button className="disablebutton">Add Gems Protect</button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Banner;
